import React, { Component, Text, useState, useRef, useEffect, useContext } from 'react'
import { Navbar, NavbarBrand, Nav, NavItem, Row, NavbarToggler, Collapse, Col, Modal, FormGroup, Input, Button, FormFeedback, Container, CardBody, Card, CardImg, ModalHeader, ModalBody } from 'reactstrap';
import logo from '../../Assets/finalLogo01.png'
import beautyLogo from '../../Assets/Beauty.png'
import hairLogo from '../../Assets/image-11.png'
import autoLogo from '../../Assets/autocare-1.png'
import nailLogo from '../../Assets/image-12.png'
import locationIcon from '../../Assets/icon-location-on.png'
import locationcolorIcon from '../../Assets/colorLocation.png'
import arrowBack from '../../Assets/arrowBack.png'
import searchIcon from '../../Assets/searchIcon.png'
import curLocationIcon from '../../Assets/currentLocation.png'
import historyLocationIcon from '../../Assets/historyLocation.png'
import OtpInput from 'react-otp-input';
import NavBarV2 from '../../Components/Custom/UI/NavBarLatest';
import '../../CSS/HomePage.css'
import CategoryCards from '../../Components/Custom/UI/CategoryCards';
import { useMediaQuery } from "react-responsive"
import NearByProCards from '../../Components/Custom/UI/NearByProCards';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import RightArrow from '../../Assets/ic-round-arrow-back-ios.png'
import WhySlashNew from './WhySlashNew';
import WhyNewSlash_Mobile from './WhyNewSlash_Mobile';
import CitySpecificBannerHome from './CitySpecificBannerHome';
import DownloadOurApp from './DownloadOurApp';
import DownloadOurApp_Mobile from './DownloadOurApp_Mobile';
import FindoutWhatAreULooking from './FindoutWhatAreULooking';
import FooterSv2 from './FooterSv2';
import FooterSv2_Mobile from './FooterSv2_Mobile';
import { useNavigate,NavLink, parsePath } from 'react-router-dom';
import PlacesAutocomplete,{
   geocodeByAddress,
   geocodeByPlaceId,
   getLatLng,
 } from 'react-places-autocomplete';
import { offersDataJSONUs, offersDataJSONIn } from './ServiceStaticArray'
import FetchCurrentLocation from '../../Components/Custom/FetchCurrentLocation';
import { globalState } from '../../GlobalState/globalState';
import { ClipLoader } from 'react-spinners';
import CurrentLocationIcon from '../../Assets/icon-my-location.png'
import CloseIcon from '../../Assets/icons-closeModal.png'
import RecentLocIcon from '../../Assets/material-symbols-history-rounded.png'
import GreyLocIcon from '../../Assets/icon-location-Grey.png'
import NearByProfessionalMapView from './NearByProfessionalMapView';
import { MdOutlineEdit } from "react-icons/md";
import InputComponent from '../../Components/Custom/UI/InputComponent';
import { ToastContainer, toast } from 'react-toastify';
import customFetchData from '../../Components/Custom/customFetchData';
import { IoLocationSharp } from 'react-icons/io5';
import GoogleMapReact from 'google-map-react';
import { clearCart, clearDateAndTime, storeAddress, storeServices } from '../../GlobalState/globalStateActions';
import CurrentLocationIconRed from '../../Assets/icon-my-locationIcon.png'
import SearchCrossIcon from '../../Assets/group-383.png'
import ReferAndEarn from './ReferAndEarnHome';
import ReferAndEarnHome from './ReferAndEarnHome';
import { catColors } from '../../Components/Custom/UI/Colors';
import SavedAddresses from '../ProfileStack/SavedAddresses';
import Testimonials from  '../../../New_Website_V2/Components/TestimonialsV2';
import {Helmet} from "react-helmet";
import { apiKeys } from '../../../config';
import WhyChooseSlash from '../../Components/Custom/UI/WhyChooseSlash';
import WhyChooseSlash_Mobile from '../../Components/Custom/UI/WhyChooseSlash_Mobile';
import BookAserviceWithUs from '../../Components/Custom/UI/BookAserviceWithUs';
import useDebounce from '../../Components/Custom/Hooks/useDebounce';
import NewProfessionalCard from '../../Components/Custom/UI/NewProfessionalCard';
const DeepClone = require("rfdc/default")
let localStorage=window.localStorage
// console.log('localStorage',localStorage)

function LandingPageV2() {
  
   const useMobileAndBelowMediaQuery = () => useMediaQuery({ query: "(max-width: 760px)" })
   const useTabletMediaQuery = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })
   const isMobileView = useMobileAndBelowMediaQuery()
   const isTabView = useTabletMediaQuery()
   const [state,dispatch]=useContext(globalState)
   // const [country, setCoutry] = useState('India')
   const [modalInd, setModalInd] = useState(false)
   const [modalUSA, setModalUSA] = useState(false)
   const [modalOTP, setModalOTP] = useState(false)
   const [locModal, setlocModal] = useState(false)
   const [serviceModal, setserviceModal] = useState(false)
   const [query, setquery] = useState('')
   // const [state, setstate] = useState({ query: '', list: [] })
   const searchInput = useRef()
   const [otp, setOtp] = useState('')
   const [nearByPros, setNearByPros] = useState([])
   const [categories, setCategories] = useState([])
   const [subCategories, setSubCategories] = useState([])
   const [mpidArr, setMpidArr] = useState([])
   const [searchText,setSearchText]=useState('')
   const [showSearchDropDown,setShowSearchDropDown]=useState(false)
   const [searchTextOffer,setSearchTextOffer]=useState('')
   const [filteredArray,setFilteredArray]=useState([])
   const [nearestPros,setNearestPros]=useState([])
   const [searchDropdownArray,setSearchDropdownArray]=useState([])
   const [clickOnOfferSearch,setClickOnOfferSearch]=useState(false)
   const [didClearSearch,setDidClearSearch]=useState(false)
   const [searchAddModalOpen, setSearchAddModalOpen] = useState(false)
   const [totalAddress,setTotalAddress]=useState('')
   const [latitude,setLatitude]=useState()
   const [longitude,setLongitude]=useState()
   const [stateOrProvince,setStateOrProvince]=useState('')
   const [city,setCity]=useState('')
   const [zipcode,setZipcode]=useState()
   const [country,setCountry]=useState('')
   const [district,setDistrict]=useState('')
   const [addressLine1,setAddressLine1]=useState('')
   const [loading,setloading]=useState(false)
   const [loadingL,setloadingL]=useState(false)
   const [loadingL1,setloadingL1]=useState(false)
   const [loadingCat,setLoadingCat]=useState(true)
   const [currentLocModal,setCurrentLocModal]=useState(false)
   const [currentAddress,setCurrentAddress]=useState('')
   const [addressSearchModal,setAddressSearchModal]=useState(false)
   const [recentSearchesArray,setRecentSearchesArray]=useState([])
   const [recentLocationsHide,setRecentLocationsHide]=useState(false)
   const [seeByMapModalWeb,setSeeByMapModalWeb]=useState(false)
   const [seeByMapModalMobile,setSeeByMapModalMobile]=useState(false)
   const [saveAddressModal,setSaveAddressModal]=useState(false)
   const input_Ref1 = useRef();
   const input_Ref2 = useRef();
   const [clickedValue,setClickedValue]=useState([])
   const [selectedTag,setSelectedTag]=useState('Home');
   const [mapViewModal,setMapViewModal]=useState(false)
   const [mapViewModalWeb,setMapViewModalWeb]=useState(false)
   const [editNewAddressModal,setEditNewAddressModal]=useState(false)
   const [categoryName,setCategoryName]=useState('')
   const debouncedSearchText = useDebounce(searchTextOffer, 500);
   const [recentResultsNotFound, setRecentResultsNotFound] = useState(false)
   const [searchRequested, setSearchRequested] = useState(false)
   const [serviceSearchPros, setServiceSearchPros] = useState([])
   const [serviceSearched, setServiceSearched] = useState(false)
   const [hiderecentSearches, setHiderecentSearches] = useState(false)
   const [searchModalOpen, setSearchModalOpen] = useState(false)
   const [noResSearchCard, setNoResSearchCard] = useState("")
   const [serSearchProsLoading, setSerSearchProsLoading] = useState(false)
   const [serviceSearchedName, setServiceSearchedName] = useState('')
   const mapRef=useRef()
   let placesArray=
    [
        {
            id:1,
            place:'Home'
        },
        {
            id:2,
            place:'Work'
        },
        {
            id:3,
            place:'Hotel'
        },
        {
            id:4,
            place:'Others'
        }
    ]
    const [allValues, setAllValues] = useState({
      cmptAddress: '',
      floor: '',
      landmark: '',
      status: '',
      message: '',
      addError: false,
      floorError: false,
      landError: false
  })
  const [cityNotYet,setCityNotYet]=useState(false)
  const [checked,setChecked]=useState([])
  const [defaultProps,setDefaultProps]=useState({
     center: {
        lat: 0,
        lng: 0
     },
     zoom: 10
  })
  const [addressUpDated,setAddressUpDated]=useState(false)
  const [currentTextClick,setCurrentTextClick]=useState(false)
  const [curLocationDenied,setCurLocationDenied]=useState(false)
  const [fetchedDataResponse,setFetchedDataResponse]=useState([])
  const [editAddress,setEditAddress]=useState({})
  const searchAddRef=useRef()
  const searchAddRef1=useRef()
  const searchAddRefMob=useRef()
   const navigate = useNavigate();
   window.scrollTo(0,0)
   // console.log("state.address.totalAddress",state.address.totalAddress)
   // useLayoutEffect(()=>{console.log("test use effect")},[])
   const fetchSavedAddresses = async() => {
      let body={
          uid:state.user.id
      }
      let method = 'POST';
      let url = "/website/fetchSavedAddress/sv2"
      let DataResponse= await customFetchData(method, body, url, state, dispatch)
      // console.log('fetch data',DataResponse)
      if(DataResponse.fetch){
          let addressResult=DataResponse.fetchedData.fetchAddressResult
          if(addressResult.length!==0){
              setFetchedDataResponse(addressResult)
          }
      }
   }
   useEffect(() => {
    
      if(state.token){
         fetchSavedAddresses()
      }
      console.log('selected service tab use effect',state.selectedServiceTab)
      fetchServiceData()
     
   },[state.selectedServiceTab,state.addressUpdated])
   let fetchServiceData= async() =>{
      try{
         setCategories([])
         setSubCategories([]) 
         setNearestPros([])
         setMpidArr([])
         console.log('state.address in use effect',state.address)
        //  clearDateAndTime(dispatch)
        //  if(state.services.length==0 || addressUpDated){
            console.log('..state services empty check.. or ..address update..', state.address)
            let city_data;
            // if(state.address.searchAddress === false && state.address.currentAddress === true){
            //    console.log("state.address.searchAddress === false && state.address.currentAddress === true",state.address.searchAddress === false && state.address.currentAddress === true)
            //       if(currentTextClick){
            //          console.log("currentTextClick",currentTextClick)
            //          if (state.address) {
            //             let region={
            //                   center: {
            //                       lat:state.address.latitude,
            //                       lng:state.address.longitude
            //                   },
            //                   zoom: 15
            //             }
            //             // mapRef.current.animateToRegion(region);
            //             setDefaultProps(region)
            //             setAddressLine1(state.address.addressLine1)
            //             setCountry(state.address.country)
            //             setCity(state.address.city)
            //             setDistrict(state.address.district)
            //             setTotalAddress(state.address.totalAddress)
            //             setStateOrProvince(state.address.stateOrProvince)
            //             setZipcode(state.address.zipcode)
            //             setLatitude(state.address.latitude)
            //             setLongitude(state.address.longitude)
            //             // setloadingL(false)
            //             // setloadingL1(false)
            //             city_data={
            //                curr_city: state.address.city,
            //                curr_lat: state.address.latitude,
            //                curr_long: state.address.longitude,
            //                stateOrProvince:state.address.stateOrProvince,
            //              }
            //             setCurLocationDenied(state.address.currentLocationDenied)
            //          }
                     
            //       }else{
            //          setloadingL(true)
            //          setloadingL1(true)
            //          if (state.address) {
            //             let region = {
            //                center: {
            //                   lat: state.address.latitude,
            //                   lng: state.address.longitude
            //                },
            //                zoom: 15
            //             }
            //             setDefaultProps(region)
            //             setLatitude(state.address.latitude)
            //             setloadingL(false)
            //             setTotalAddress(state.address.totalAddress)
            //             setloadingL1(false)
            //             setAddressLine1(state.address.addressLine1)
            //             setCity(state.address.city)
            //             setCountry(state.address.country_name)
            //             setZipcode(state.address.zipcode)
            //             setStateOrProvince(state.address.stateOrProvince)
            //             setDistrict(state.address.district)
            //             setLongitude(state.address.longitude)
            //             setCurLocationDenied(false)
            //             city_data = {
            //                curr_city: state.address.city,
            //                curr_lat: state.address.latitude,
            //                curr_long: state.address.longitude,
            //                stateOrProvince: state.address.stateOrProvince,
            //                selectedServiceTab:state.selectedServiceTab ? state.selectedServiceTab : 'at_home'
            //             }
            //          }
            //       }
            //    // }
            // }else if(state.address.searchAddress === true && state.address.currentAddress === false){
            //    console.log("state.address.searchAddress === false && state.address.currentAddress === true",state.address.searchAddress === false && state.address.currentAddress === true)
            //    if (state.address) {
            //       let region={
            //             center: {
            //                 lat:state.address.latitude,
            //                 lng:state.address.longitude
            //             },
            //             zoom: 15
            //       }
            //       // mapRef.current.animateToRegion(region);
            //       setDefaultProps(region)
            //       setAddressLine1(state.address.addressLine1)
            //       setCountry(state.address.country)
            //       setCity(state.address.city)
            //       setDistrict(state.address.district)
            //       setTotalAddress(state.address.totalAddress)
            //       setStateOrProvince(state.address.stateOrProvince)
            //       setZipcode(state.address.zipcode)
            //       setLatitude(state.address.latitude)
            //       setLongitude(state.address.longitude)
            //       city_data={
            //          curr_city: state.address.city,
            //          curr_lat: state.address.latitude,
            //          curr_long: state.address.longitude,
            //          stateOrProvince:state.address.stateOrProvince,
            //          selectedServiceTab:state.selectedServiceTab ? state.selectedServiceTab : 'at_home'
            //        }
            //    }
            // }
          city_data = {
              curr_city: state.address.city,
              curr_lat: state.address.latitude,
              curr_long: state.address.longitude,
              stateOrProvince: state.address.stateOrProvince,
              selectedServiceTab:state.selectedServiceTab ? state.selectedServiceTab : 'at_home'
          }
          setTotalAddress(state.address.totalAddress)
            setLoadingCat(true)

            //// original route to be uncommented
            if(state.user.id && state.token)
            {
               city_data.consumerId=state.user.id
            }
            console.log("city_data before fetchLocation",city_data)
            let {fetchedData}=await customFetchData('POST',city_data,'/website/fetchCurrentLocationCatsAndPros/LandingPage',state,dispatch)
            console.log("offer data",fetchedData)
            if(fetchedData.getOff)
            {
               //   console.log("inside use effect home page")
               setCategories(fetchedData.catsFinal)
               setSubCategories(fetchedData.subcatsFinal)
               // setNearByPros(fetchedData.offers)
               let mpidArr = [];
               mpidArr = fetchedData.mpidArr
               setNearByPros(fetchedData.offers)
               setFilteredArray(fetchedData.offers)
               setNearestPros(fetchedData.nearestPros && fetchedData.nearestPros.length>0 ? fetchedData.nearestPros : [])
               // storeServices(fetchedData.offers,fetchedData.catsFinal,fetchedData.subcatsFinal,dispatch)
               setMpidArr(fetchedData.mpidArr)
            }
            else
            {
              if(fetchedData.cityNotYet)
              {
                setCityNotYet(true)
              }
              else
              {
                toast.error("Something went wrong. Please try later.", {position:toast.POSITION.BOTTOM_CENTER});
              }
              setCategories([])
              setSubCategories([])
              setNearByPros([])
              setFilteredArray([])
              storeServices([],[],[],dispatch)
            }
            setLoadingCat(false)
            setShowSearchDropDown(false)
            setSearchTextOffer('')
            setSearchDropdownArray([]) 
            // local storage handler
            localStorageHandler()
            placesArray.map((item,index)=>{
               if(item.id === 1){
                   // console.log('place array1',item)
                  return  clickedValue['clickedValue_'+ item.id]=true
                   
               }else{
                   // console.log('place array2',item)
                  return clickedValue['clickedValue_'+ item.id]=false
                   // console.log('placse array',clickedValue)
               }
           })  
        //  }
        //  else{
        //    //// Else case to prevent default reloading
        //     setLoadingCat(true)
        //     if(state.services.length!==0){
        //     console.log("global services dispatching to state again")
        //           if (state.address) {
        //              let region={
        //                    center: {
        //                        lat:state.address.latitude,
        //                        lng:state.address.longitude
        //                    },
        //                    zoom: 15
        //              }
        //              // mapRef.current.animateToRegion(region);
        //              setDefaultProps(region)
        //              setAddressLine1(state.address.addressLine1)
        //              setCountry(state.address.country)
        //              setCity(state.address.city)
        //              setDistrict(state.address.district)
        //              setTotalAddress(state.address.totalAddress)
        //              setStateOrProvince(state.address.stateOrProvince)
        //              setZipcode(state.address.zipcode)
        //              setLatitude(state.address.latitude)
        //              setLongitude(state.address.longitude)
        //              if(state.address.currentAddress){
        //                 setCurrentAddress(state.address.totalAddress)
        //              }
        //              setCurLocationDenied(state.address.currentLocationDenied)
        //           }
        //           let offers = DeepClone(state.services)
        //           let categoryArr = DeepClone(state.categories)
        //           let subcatArr = DeepClone(state.subcategories)
        //           // console.log("inside use effect else case",offers,categoryArr,subcatArr)
        //           if(offers.length!==0){
        //              setCategories(categoryArr)
        //              setSubCategories(subcatArr)
        //              let mpidArr=[];
        //              mpidArr=offers.map(item=>{
        //                 return item[0].QF_MERCHANT_PERSONNEL_PRID
        //              })
        //              if (mpidArr !== 0) {
        //                 let body = {
        //                    mpidArr: mpidArr,
        //                    consumer_prid: state.user.id,
        //                    wishlistType: 'professional'
        //                 }
        //                 setNearByPros(offers)
        //                 setFilteredArray(offers)
        //                 storeServices(offers,categoryArr,subcatArr,dispatch)
                        
        //                 setMpidArr(mpidArr)
        //              }
        //              setLoadingCat(false)
        //           }
        //           setShowSearchDropDown(false)
        //           setSearchTextOffer('')
        //           setSearchDropdownArray([])
        //           // local storage handler
        //           localStorageHandler()
        //           placesArray.map((item, index) => {
        //              if (item.id === 1) {
        //                 // console.log('place array1',item)
        //                 return clickedValue['clickedValue_' + item.id] = true
      
        //              } else {
        //                 // console.log('place array2',item)
        //                 return clickedValue['clickedValue_' + item.id] = false
        //                 // console.log('placse array',clickedValue)
        //              }
        //           })
        //     }
            
        //  }
      }catch(error){
         console.log('error',error)
      }
   }
   useEffect(() => {
        if (debouncedSearchText && String(debouncedSearchText).trim().length > 3) {
            performSearch(debouncedSearchText);
        } else {

        }
    }, [debouncedSearchText]);
    const performSearch = async (query) => {
        try {
            console.log('in perform search', query)
            if (query.length > 2) {
                const body = {
                    query: query,
                    mpidArr: mpidArr,
                    fromAtHomePage: state.selectedServiceTab === 'at_home' ? true : false,
                    country: state.address.country ? state.address.country : 'IN',
                }
                let userDataforRate = await customFetchData('POST', body, '/website/homepage/Cat_Ser_Pro/Search', state, dispatch)
                console.log('userDataforRate', userDataforRate)
                let filteredOffers = DeepClone(nearByPros), filteredOffers1 = DeepClone(userDataforRate?.fetchedData?.serviceData || []), matchesArr = [], catsFinalData = DeepClone(categories)
                query = query ? query.trim() : query
                setShowSearchDropDown(true)
                catsFinalData.map((insideItem) => {
                    if (insideItem.category_name.search(new RegExp(query, 'i')) !== -1) {
                        insideItem.type = 'Category'
                        // console.log("matchesArr in cat filter", insideItem);
                        matchesArr.push(insideItem)
                    }
                })
               if(state.selectedServiceTab === 'at_home'){
               }
               else{
                  filteredOffers.map((insideItem) => {
                     if (insideItem && insideItem.MERCHANT_NAME && insideItem.MERCHANT_NAME.search(new RegExp(query, 'i')) !== -1) {
                        insideItem.type = 'Professional'
                        matchesArr.push(insideItem)
                     }
                  })
               }
               filteredOffers1.map((insideItem) => {

                  if (insideItem && insideItem.SERVICE_NAME && insideItem.SERVICE_NAME.search(new RegExp(query, 'i')) !== -1) {
                     insideItem.type = 'Service'
                     // console.log("matchesArr in service filter",insideItem);
                     matchesArr.push(insideItem)
                  }

                })
                // console.log("matchesArr outside",matchesArr);
                let catArray, proArray, servicesArray;
                catArray = matchesArr.filter(item => {
                    return item.type == "Category"
                })
                servicesArray = matchesArr.filter(item => {
                    return item.type == 'Service'
                })
                proArray = matchesArr.filter(item => {
                     console.log('item',item)
                    return item.type == "Professional"
                })
                // console.log('all',proArray,catArray,servicesArray)
                let finalArray = [];
                if (proArray.length !== 0) {
                    // console.log('pro dataaaa',proArray)
                    proArray.map(item => {
                        finalArray.push(item);
                    })
                }
                if (catArray.length !== 0) {
                    // console.log('cat dataaaa',catArray)
                    catArray = catArray.filter((v, i, a) => a.findIndex(t => ((t.category_name === v.category_name))) === i)
                    catArray.map(item => {
                        finalArray.push(item);
                    })
                }
                if (servicesArray.length !== 0) {
                    servicesArray = servicesArray.filter((v, i, a) => a.findIndex(t => ((t.SERVICE_NAME === v.SERVICE_NAME))) === i)
                    servicesArray.map(item => {
                        finalArray.push(item);
                    })
                }
                console.log('final array', finalArray)
               //  setTimeout(() => {
                  console.log('final array after 10s', finalArray)
                    setSearchDropdownArray(finalArray);  // Set search results after 10s
               //  }, 1000);
            }
            else {
                setShowSearchDropDown(false)
                if (!didClearSearch) {
                    setDidClearSearch(true)
                }
                setSearchDropdownArray([])
            }
        }
        catch (err) {
            console.log("search error", err)
        }
    };
   const localStorageHandler = async() => {
      let getValue=await localStorage.getItem("qf:recent:address")
      // console.log("value in use effect",JSON.parse(getValue))
      setRecentSearchesArray(JSON.parse(getValue) !==null ? JSON.parse(getValue) : [])
   }
   const currentLocationFunc=async(fromClickCurrent)=>{
      setloadingL(true)
      setloadingL1(true)
      if(fromClickCurrent) {
         setCurrentLocModal(false)
         setCurrentTextClick(true)
      } 
      // console.log('curLocationDenied',curLocationDenied)
      if(curLocationDenied){
         // setMapViewModal(false)
         setTotalAddress(state.address.totalAddress)
         // console.log('total address',state.address.totalAddress)
         setloadingL(false)
         setloadingL1(false)
         if(isMobileView){
            setAddressSearchModal(true)
         }
         // console.log('curLocationDenied',curLocationDenied)
         toast.error(
            <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
               <text style={{textAlign:'center'}}>Please enable your location from your browser settings</text>
            </div>
            , {
            position: "bottom-center",
            hideProgressBar: true,
            progress: undefined,
            closeButton:false,
            style:{backgroundColor:'#E0D1FF'}
        });
         // toast.error(<text style={{textAlign:'center'}}>Please enable your location from your browser settings</text>, { position: isMobileView ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_CENTER })
      }else{
         // setAddressUpDated(true)
         if(isMobileView){
            setMapViewModal(true)
         }else{
            setMapViewModalWeb(true)
         }
         let addressDetails= await FetchCurrentLocation(state,dispatch,fromClickCurrent)
         console.log('address',addressDetails)
         if(addressDetails.locationFetch){
            let {addressLine1,city,country,curr_location_latitude,curr_location_longitude,currentLocation,district,stateOrProvince,zipcode,currentAddress}=addressDetails
            let region={
               center: {
                   lat:curr_location_latitude,
                   lng:curr_location_longitude
               },
               zoom: 15
            }
            setDefaultProps(region)
            setLatitude(curr_location_latitude)
            setLongitude(curr_location_longitude)
            if (currentAddress || state.address.currentAddress) {
               setCurrentAddress(currentLocation)
            }
            setTotalAddress(currentLocation)
            setloadingL(false)
            setloadingL1(false)
            setAddressLine1(addressLine1)
            setCity(city)
            setCountry(country)
            setZipcode(zipcode)
            setStateOrProvince(stateOrProvince)
            setDistrict(district)
            // if(!isMobileView){
            //    setAddressUpDated(true)
            //    dispatch({type:'SET_ADDRESS_UPDATED',addressUpdated:!state.addressUpdated})
            // }
         }else{
            if(addressDetails.currentLocationDenied){
               let {addressLine1,city,country,curr_location_latitude,curr_location_longitude,currentLocation,district,stateOrProvince,zipcode,currentAddress}=addressDetails
               let region={
                  center: {
                      lat:curr_location_latitude,
                      lng:curr_location_longitude
                  },
                  zoom: 15
               }
               setDefaultProps(region)
               setLatitude(curr_location_latitude)
               setloadingL(false)
               setTotalAddress(currentLocation)
               setloadingL1(false)
               setAddressLine1(addressLine1)
               setCity(city)
               setCountry(country)
               setZipcode(zipcode)
               setStateOrProvince(stateOrProvince)
               setDistrict(district)
               setLongitude(curr_location_longitude)
               setCurLocationDenied(addressDetails.currentLocationDenied)
               // if (currentAddress || state.address.currentAddress) {
               //    setCurrentAddress(currentLocation)
               // }
            }
         }
      }
   }
   let categoryCards, nearByProCardDisplay;
   if (categories.length !== 0) {
      categoryCards = (
         categories.map((item, index) => {
            return (
               <div className='categoryCardWidth'>
                  <CategoryCards 
                     onClick={()=>{navigate({
                        pathname: state.selectedServiceTab == 'at_home' ? `allservices` : `/allprofessionals`,
                        search: `?category=${item.category_name.replaceAll(" ","-","g")}&categoryId=${item.QF_SERVICE_CATEGORY_PRID}`
                      },{state:{categories,subCategories,nearByPros,catItem:item,mpidArr,catPrid:item.QF_SERVICE_CATEGORY_PRID,fromExplore:false,fromSearch:false
                        ,addressDetails:
                        {
                           totalAddress: totalAddress,
                           addressLine1: addressLine1,
                           country: country,
                           city: city,
                           stateOrProvince: stateOrProvince,
                           zipcode: zipcode,
                           district: district,
                           latitude: latitude,
                           longitude: longitude,
                           currentAddress: state.address.currentAddress,
                           searchAddress: state.address.searchAddress,
                           currentLocationDenied: state.address.currentLocationDenied
                        }}})
                        setCategoryName(item.category_name)
                     }} 
                     categoryName={item.category_name} uri={item.category_image ? item.category_image : ''} style={{ marginTop: 16, marginRight: 2 }} />
               </div>
            )
         })
      )
   }else{
      categoryCards=(
         <div>
            <text>No Categories to display</text>
         </div>
      )
   }
   // Near by pro cards carousel
   const ButtonGroup = ({ next, previous, ...rest }) => {
      const {
         carouselState: { currentSlide, totalItems, slidesToShow }
      } = rest;

      return (
         <div>
            <div className="arrowLandSv2">
               <Card  className={currentSlide === 0 ? "disable_arrowLandLeftSv2" : "arrowLandLeftSv2"} onClick={() => previous()}>
                  <CardImg src={RightArrow} style={{ transform: 'rotate(180deg)' }} className={"carousel_arrowLandingSv2"} />
               </Card>
               <Card className={currentSlide === totalItems - slidesToShow ? "disable_arrowLandRightSv2" : "arrowLandRightSv2"} onClick={() => next()}>
                  <CardImg src={RightArrow} className={"carousel_arrowLandingSv2"} />
               </Card>
            </div>
         </div>
      );
   };
   const responsive = {
      desktop: {
         breakpoint: { max: 3000, min: 1100 },
         items: 4,
         slidesToSlide: 1 // optional, default to 1.
      },
      laptop: {
         breakpoint: { max: 1100, min: 900 },
         items: 3,
         slidesToSlide: 2 // optional, default to 1.
      },
      tablet: {
         breakpoint: { max: 900, min: 600 },
         items: 2.5,
         slidesToSlide: 2 // optional, default to 1.
      },
      TabMobile:{
         breakpoint: { max: 600, min: 340 },
         items: 1.3,
         slidesToSlide: 2
      },
      mobile: {
         breakpoint: { max: 340, min: 0 },
         items: 1.15,
         slidesToSlide: 1 // optional, default to 1.
      }
   };
   const WishlistPressHandler = async(item) =>{
      // console.log("pressed",item)
      nearByPros.map(list=>{
        // console.log('list',list[0])
        if(list[0].QF_MERCHANT_PERSONNEL_PRID === item.QF_MERCHANT_PERSONNEL_PRID){
          // console.log(list[0].QF_MERCHANT_PERSONNEL_PRID === item.QF_MERCHANT_PERSONNEL_PRID,'list')
          return setChecked((prevState)=>{
            return {
              ...prevState,
              ['checked_' + list[0].QF_MERCHANT_PERSONNEL_PRID]:!checked['checked_' + list[0].QF_MERCHANT_PERSONNEL_PRID]
            }
          }) 
        }
    })
      let body={
        // cprid:item.QF_CONSUMER_PRID,
        cprid:state.user.id,
        mpprid:item.QF_MERCHANT_PERSONNEL_PRID,
        wishLstType:'professional'
      }
      // setWishlistPress(!wishlistPress)
      let WishlistInsert=await customFetchData('POST',body,'/website/add/wishList/sv2',state,dispatch)
      // console.log('wish list response',WishlistInsert)
    }
   let sortedNearByPros;
   if (nearestPros.length !== 0) {
      let nearByProsDup=DeepClone(nearestPros)
      // console.log('nearByProsDup',nearByProsDup)
      sortedNearByPros= nearByProsDup.sort((a,b)=>{
         return a.distance - b.distance
      })
      nearByProCardDisplay = (
         <Carousel
            infinite={false}
            swipeable={isMobileView ? true : false}
            draggable={false}
            showDots={false}
            arrows={false}
            // focusOnSelect={true}
            // renderButtonGroupOutside={false}
            customButtonGroup={<ButtonGroup />}
            // itemClass="image-item"
            responsive={responsive}
            transitionDuration={500}
            containerClass="carousel_container_nearbypros"
            renderArrowsWhenDisabled={true}

         >
            {
               sortedNearByPros.map((item, index) => {
                  // console.log('console in Home',item[0])
                  return (
                     <NearByProCards state={state} data={item} key={index}  onClickCard={()=>navigate({pathname:`/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ","","g")}`,search:`?proId=${item.QF_MERCHANT_PERSONNEL_PRID}`},{ state: {proData:item,proChecked:checked['checked_'+ item.QF_MERCHANT_PERSONNEL_PRID] ? true : false,
                        categories:categories,subCategories:subCategories,
                        addressDetails:
                     {
                        totalAddress: totalAddress,
                        addressLine1: addressLine1,
                        country: country,
                        city: city,
                        stateOrProvince: stateOrProvince,
                        zipcode: zipcode,
                        district: district,
                        latitude: latitude,
                        longitude: longitude,
                        currentAddress: state.address.currentAddress,
                        searchAddress: state.address.searchAddress,
                        currentLocationDenied: state.address.currentLocationDenied
                     },
                     offers:item,allServices:nearByPros,proChecked:checked['checked_'+ item.QF_MERCHANT_PERSONNEL_PRID] ? true : false} })}/>
                  )
               })
            }
         </Carousel>
      )
   }
   let  width  = window.innerWidth
   let widthCal='75%';
   // if (categories.length !== 0 && !isMobileView && !isTabView && state.selectedServiceTab ==='at_home') {
   //    widthCal = '53%'
   // }
   //  if (categories.length !== 0 && !isMobileView && !isTabView) {
   //    if (categories.length == 4) {
   //       widthCal = '55%'
   //    } else {
   //       widthCal = '90%'
   //    }
   // }
   if (isMobileView) {
      widthCal = '100%'
   }
   if(isTabView){
      widthCal = '95%'
   }
   // Address related functions

   const handleChange = address => {
      setTotalAddress(address)
      // console.log('address',address)
      // setSearchText(address)
      if(address.length>2){
         setCurrentLocModal(false)
      }
   };
  const handleSelect = async(address) => {
      // console.log('address',address)
      searchAddRef.current.blur();
      setMapViewModalWeb(true)
      // setAddressUpDated(true)
      setCurrentLocModal(false)
      geocodeByAddress(address)
        .then(results => {
         //   setSearchText(results[0])
         getLatLng(results[0])
           .then(latlng =>{
               // console.log('Successfully got latitude and longitude', latlng)
               setLatitude(latlng.lat)
               setLongitude(latlng.lng)
               if(latlng.lat!==null && latlng.lng!==null){
                  let region = {
                     center: {
                        lat:latlng.lat,
                        lng:latlng.lng
                     },
                     zoom: 15
                  }
                  // mapRef.current.animateToRegion(region);
                  setDefaultProps(region)
                 fetchAddress(latlng.lat,latlng.lng)
               //   saveLocationsInLocal(results[0].formatted_address,latlng.lat,latlng.lng)
               }
            }).then(latLng => console.log('Success', latLng))
            .catch(error => console.error('Error', error)); 
         })
  };
const fetchAddress = async(latitude,longitude) => {
   // setCityInValid(false)
   clearCart(dispatch)
   setloadingL(true)
   setloadingL1(true)
   setRecentLocationsHide(false)
   setAddressSearchModal(false)
   setAddressLine1('')
   setCountry('')
   setCity('')
   setZipcode('')
   setStateOrProvince('')
   setDistrict('')
   // console.log(latitude,longitude)
   if (latitude !== null && longitude !== null) {
      setCurrentAddress('')
      const LocationStr = latitude + "," + longitude;
      let city_data={
         latitude:latitude,
         longitude:longitude
      }
      let {fetchedData,fetch}=await customFetchData('POST',city_data,'/website/getAddressFromGeocode/landingPage',state,dispatch)
      // console.log("fetchedData",fetchedData)
      if(fetchedData.data){
         let val=fetchedData.address
         //  console.log('result main', val.results[0].formatted_address)
         //  console.log('results 0' ,val.results)
          setTotalAddress(val.results[0].formatted_address)
          setSearchText('')
          if(val.status === 'OK'){
            if(val.results.length !== 0){
               let countryCheck='',totalAddress=val.results[0].formatted_address,city,zipcode,country,stateOrProvince,district,addressLine1C;
               // console.log('total address',totalAddress)
                        val.results[0].address_components.map((item, index) => {
                           if (item.types[0] == "route") {
                                 setAddressLine1(item.long_name)
                                 addressLine1C=item.long_name
                           }
                           else if (item.types[0] == "neighborhood") {
                                 if (addressLine1 == '') {
                                    setAddressLine1(item.long_name)
                                    addressLine1C=item.long_name
                                 }
                                 else if (!isNaN(Number(addressLine1))) {
                                    // let street_route = addressLine1.concat(' ').concat(item.long_name)
                                    // setAddressLine1(prevState => ([...prevState,...street_route]))
                                    setAddressLine1(item.long_name)
                                    addressLine1C=item.long_name
                                 }
                                 else {
                                    // let street_route = addressLine1.concat(', ').concat(item.long_name)
                                    // setAddressLine1(prevState => ([...prevState,...street_route]))
                                    setAddressLine1(item.long_name)
                                    addressLine1C=item.long_name
                                 }
                           }
                           else if (item.types[0] == "political") {
                                 if (addressLine1 == '') {
                                    setAddressLine1(item.long_name)
                                    addressLine1C=item.long_name
                                 }
                                 else {
                                    // let street_route = addressLine1.concat(', ').concat(item.long_name)
                                    // setAddressLine1(prevState => ([...prevState,...street_route]))
                                    setAddressLine1(item.long_name)
                                    addressLine1C=item.long_name
                                 }
                           }else if(item.types[0] == "establishment"){
                              if (addressLine1 == '') {
                                 setAddressLine1(item.long_name)
                                 addressLine1C=item.long_name
                              }
                              else {
                                 // let street_route = addressLine1.concat(', ').concat(item.long_name)
                                 // setAddressLine1(prevState => ([...prevState,...street_route]))
                                 setAddressLine1(item.long_name)
                                 addressLine1C=item.long_name
                              }
                           }
                           else if(item.types[0] == "administrative_area_level_3" || item.types[0] == "administrative_area_level_2"){
                                 setDistrict(item.long_name)
                                 district=item.long_name
                           }
                           else if (item.types[0] == "administrative_area_level_1") {
                                 setStateOrProvince(item.long_name)
                                 stateOrProvince=item.long_name
                                 // console.log("state", item.long_name)
                           }
                           else if (item.types[0] == "country") {
                                 countryCheck=item.long_name
                                 setCountry(item.long_name)
                                 country=item.long_name
                                 // console.log("country", item.long_name)
                           }
                           else if (item.types[0] == "postal_code") {
                                 setZipcode(item.long_name)
                                 zipcode=item.long_name
                                 // console.log("zipcode", item.long_name)
                           }
                           else {
                                 console.log("else")
                           } 
                        })
                        if(countryCheck.includes('India')){
                           val.results.map(item1=>{
                                 // console.log("city", item1)
                                 if (item1.types[0] == "locality") {
                                    setCity(item1.address_components[0].long_name)
                                    city=item1.address_components[0].long_name
                                    // console.log("city", item1.long_name)
                                 }
                           })
                     
                        }else{
                           val.results[0].address_components.map((item1,index)=>{
                                 if (item1.types[0] == "locality") {
                                    setCity(item1.long_name)
                                    city=item1.long_name
                                    // console.log("city", item1.long_name)
                                 }
                           })
                        }
                        setloadingL1(false)
                        setloadingL(false)
            }
          }
      }else{
         setloadingL1(false)
         setloadingL(false)
      }
   }
}
const fetchAddressRecent = async(latitude,longitude) =>{
   clearCart(dispatch)
   setloadingL(true)
   setloadingL1(true)
   setRecentLocationsHide(false)
   setAddressSearchModal(false)
   setAddressLine1('')
   setCountry('')
   setCity('')
   setZipcode('')
   setStateOrProvince('')
   setDistrict('')
   // console.log(latitude,longitude)
   if (latitude !== null && longitude !== null) {
      setCurrentAddress('')
      let city_data={
         latitude:latitude,
         longitude:longitude
      }
      let {fetchedData,fetch}=await customFetchData('POST',city_data,'/website/getAddressFromGeocode/landingPage',state,dispatch)
      // console.log("fetchedData",fetchedData)
      if(fetchedData.data){
         let val=fetchedData.address
             setTotalAddress(val.results[0].formatted_address)
             setSearchText('')
             if(val.status === 'OK'){
                 if(val.results.length !== 0){
                     setloadingL1(false)
                     setloadingL(false)
                     let countryCheck='',totalAddress=val.results[0].formatted_address,city,zipcode,country,stateOrProvince,district,addressLine1C;
                     // console.log('total address',totalAddress)
                             val.results[0].address_components.map((item, index) => {
                                 if (item.types[0] == "route") {
                                     setAddressLine1(item.long_name)
                                     addressLine1C=item.long_name
                                 }
                                 else if (item.types[0] == "neighborhood") {
                                     if (addressLine1 == '') {
                                         setAddressLine1(item.long_name)
                                         addressLine1C=item.long_name
                                     }
                                     else if (!isNaN(Number(addressLine1))) {
                                         setAddressLine1(item.long_name)
                                         addressLine1C=item.long_name
                                     }
                                     else {
                                         setAddressLine1(item.long_name)
                                         addressLine1C=item.long_name
                                     }
                                 }
                                 else if (item.types[0] == "political") {
                                     if (addressLine1 == '') {
                                         setAddressLine1(item.long_name)
                                         addressLine1C=item.long_name
                                     }
                                     else {
                                         setAddressLine1(item.long_name)
                                         addressLine1C=item.long_name
                                     }
                                 }else if(item.types[0] == "establishment"){
                                    if (addressLine1 == '') {
                                       setAddressLine1(item.long_name)
                                       addressLine1C=item.long_name
                                   }
                                   else {
                                       setAddressLine1(item.long_name)
                                       addressLine1C=item.long_name
                                   }
                                 }
                                 else if(item.types[0] == "administrative_area_level_3" || item.types[0] == "administrative_area_level_2"){
                                     setDistrict(item.long_name)
                                     district=item.long_name
                                 }
                                 else if (item.types[0] == "administrative_area_level_1") {
                                     setStateOrProvince(item.long_name)
                                     stateOrProvince=item.long_name
                                     // console.log("state", item.long_name)
                                 }
                                 else if (item.types[0] == "country") {
                                     countryCheck=item.long_name
                                     setCountry(item.long_name)
                                     country=item.long_name
                                     // console.log("country", item.long_name)
                                 }
                                 else if (item.types[0] == "postal_code") {
                                     setZipcode(item.long_name)
                                     zipcode=item.long_name
                                     // console.log("zipcode", item.long_name)
                                 }
                                 else {
                                     console.log("else")
                                 } 
                             })
                             if(countryCheck.includes('India')){
                                 val.results.map(item1=>{
                                     // console.log("city", item1)
                                     if (item1.types[0] == "locality") {
                                         setCity(item1.address_components[0].long_name)
                                         city=item1.address_components[0].long_name
                                         // console.log("city", item1.long_name)
                                     }
                                 })
                         
                             }else{
                                 val.results[0].address_components.map((item1,index)=>{
                                     if (item1.types[0] == "locality") {
                                         setCity(item1.long_name)
                                         city=item1.long_name
                                         // console.log("city", item1.long_name)
                                     }
                                 })
                             }
                             storeAddress(totalAddress,addressLine1C,country,city,stateOrProvince,zipcode,district,latitude,longitude,false,true,state.address.currentLocationDenied,dispatch,state)                          
                             if(totalAddress!==null) {
                                saveLocationsInLocal(totalAddress,latitude,longitude)
                             }
                 }
             }
         
      }else{
         setloadingL1(false)
         setloadingL(false)
      }
   }
}
const saveLocationsInLocal = async(recentSearches,latitudeValue,longitudeValue) => {
   // console.log('pressed',recentSearches,latitudeValue,longitudeValue)
   
   try{
      setAddressUpDated(true)
      dispatch({type:'SET_ADDRESS_UPDATED',addressUpdated:!state.addressUpdated})
      setSaveAddressModal(false)
      setEditNewAddressModal(false)
      setloading(false)
      setloadingL1(false)
      setMapViewModalWeb(false)
      setMapViewModal(false)
      setAddressSearchModal(false)
       clearCart(dispatch)
           let getValue=await localStorage.getItem("qf:recent:address")
               // console.log('response',getValue);
               if(getValue === null){
                   let recentSearchesArray1=[]
                  //  console.log("recenet search array", recentSearches)
                   recentSearchesArray1.push({address:recentSearches,latitude:latitudeValue,longitude:longitudeValue})
                   let setValue=await localStorage.setItem("qf:recent:address",JSON.stringify(recentSearchesArray1))
                   console.log('set value',setValue)
               }else{
                   let array=[];
                   JSON.parse(getValue).map(item=>{
                       return array.push(item)
                   })
                   // console.log('arr1',array)
                   if(array.length === 5){
                       if(recentSearches){
                           let redundant=false;
                           array.map(i1=>{
                               if(i1.latitude === latitudeValue){
                                   return redundant=true;
                               }
                           })
                           if(redundant){
                               let setValue1=await localStorage.setItem("qf:recent:address",JSON.stringify(array))
                               let getValue1=await localStorage.getItem("qf:recent:address")
                               // console.log('recent array',JSON.parse(getValue1))
                           }else{
                               array.shift();
                               array.push({address:recentSearches,latitude:latitudeValue,longitude:longitudeValue});
                               // console.log('arr after push',array)
                               let setValue1=await localStorage.setItem("qf:recent:address",JSON.stringify(array))
                               let getValue1=await localStorage.getItem("qf:recent:address")
                              //  console.log('recent array',JSON.parse(getValue1))
                           }
                       }else{
                           let setValue1=await localStorage.setItem("qf:recent:address",JSON.stringify(array))
                           let getValue1=await localStorage.getItem("qf:recent:address")
                           // console.log('in no recent',JSON.parse(getValue1)) 
                       }
                   }else{
                       if(array.length < 5){
                           let redundant=false;
                           array.map(i1=>{
                               if(i1.latitude === latitudeValue){
                                   return redundant=true;
                               }
                           })
                           if(redundant){
                               let setValue1=await localStorage.setItem("qf:recent:address",JSON.stringify(array))
                               let getValue1=await localStorage.getItem("qf:recent:address")
                              //  console.log('recent array in else',JSON.parse(getValue1))
                           }else{
                               array.push({address:recentSearches,latitude:latitudeValue,longitude:longitudeValue})
                               let setValue1=await localStorage.setItem("qf:recent:address",JSON.stringify(array))
                               let getValue1=await localStorage.getItem("qf:recent:address")
                              //  console.log('recent array in else',JSON.parse(getValue1))
                           }
                       }
                   }
               }
               // navigation.navigate('HomePage')
       
   }catch(err){
       console.log('err',err)
   }
}
const onClickConfirmLocation = async(recentSearches,latitudeValue,longitudeValue) => {
   console.log('pressed')
   
   try{
      
      if(currentAddress){
         setEditNewAddressModal(false)
         clearCart(dispatch)
         setAddressUpDated(true)
         setMapViewModalWeb(false)
         setMapViewModal(false)
         setAddressSearchModal(false)
         dispatch({type:'SET_ADDRESS_UPDATED',addressUpdated:!state.addressUpdated})
         //   console.log('no need to save in async storage')
         //   navigation.navigate('HomePage')
         // if(isMobileView){
            storeAddress(totalAddress,addressLine1,country,city,stateOrProvince,zipcode,district,latitude,longitude,true,false,state.address.currentLocationDenied,dispatch,state)
            // dispatch({type:'SET_ADDRESS_UPDATED',addressUpdated:!state.addressUpdated})
         // }
       }else{
         // if(isMobileView){
            storeAddress(totalAddress,addressLine1,country,city,stateOrProvince,zipcode,district,latitude,longitude,false,true,state.address.currentLocationDenied,dispatch,state)
            // dispatch({ type: 'ADDRESS_STORE',totalAddress:totalAddress,addressLine1:addressLine1,country:country,city:city,stateOrProvince:stateOrProvince,zipcode:zipcode,district:district,latitude:latitude,longitude:longitude,currentAddress:false,searchAddress:true,currentLocationDenied:state.address.currentLocationDenied})
         // }
           // let removeValue=await localStorage.removeItem("qf:recent:address")
           saveLocationsInLocal(recentSearches,latitudeValue,longitudeValue)
           
       }
   }catch(err){
       console.log('err',err)
   }
}
//   search related code
   const searchBoxOfferhandler = async (event) => {
      try {
         // console.log('value in searchBoxOfferhandler', value)
         setSearchTextOffer(event.target.value)
      }
      catch (cErr) {
         console.log(cErr)
      }
   }
    const clearSearchResults = (fromBack) => {
        // console.log("calling clearSearchResults ")
        if (fromBack) {
            setSearchModalOpen(false)
        }
        setDidClearSearch(true)
        setShowSearchDropDown(false)
        setSearchTextOffer('')
        setSearchDropdownArray([])
        setRecentResultsNotFound(false)
        setSearchRequested(false)
        setNoResSearchCard("")
        setServiceSearchPros([])
        setServiceSearched(false)
        setHiderecentSearches(false)
    }
const onPressSearchDropDown = async (data, recentSearchStore, fromRecentSearches) => {
        // console.log("search_clicked_value", data,proIds,fromRecentSearches)
        console.log("search_clicked_value", data,recentSearchStore, fromRecentSearches)
        if (recentSearchStore) {
            if (data.type == 'Service') {
                setSearchTextOffer(data.SERVICE_NAME)
            }
            else {
                setSearchModalOpen(false)
                setSearchTextOffer('')
            }
            // let removeValue = await localStorage.removeItem("qf:recent:searches")
            let getValue = await localStorage.getItem("qf:recent:searches")
            // console.log('response', getValue);
            if (getValue === null) {
                let recentSearchesArray1 = []
                recentSearchesArray1.push(data)
                let setValue = await localStorage.setItem("qf:recent:searches", JSON.stringify(recentSearchesArray1))
            } else {
                let array = [];
                JSON.parse(getValue).map(item => {
                    return array.push(item)
                })
                // console.log('arr1',array)
                if (array.length === 5) {
                    if (Object.keys(data).length !== 0) {
                        let redundant = false;
                        array.map(i1 => {
                            // console.log(i1,'in length 5')
                            if ((i1.category_name === data.category_name && data.type === i1.type && data.type === 'Category') || (i1.SERVICE_NAME === data.SERVICE_NAME && data.type === i1.type && data.type === 'Service') || (i1.MERCHANT_NAME === data.MERCHANT_NAME && data.type === i1.type && data.type === 'Professional')) {
                                // console.log('search type in cat',data.type)
                                return redundant = true;
                            }
                        })
                        if (redundant) {
                            let setValue1 = await localStorage.setItem("qf:recent:searches", JSON.stringify(array))
                            let getValue1 = await localStorage.getItem("qf:recent:searches")
                            // console.log('recent array in redundant',JSON.parse(getValue1))
                        } else {
                            array.shift();
                            array.push(data);
                            // console.log('arr after push',array)
                            let setValue1 = await localStorage.setItem("qf:recent:searches", JSON.stringify(array))
                            let getValue1 = await localStorage.getItem("qf:recent:searches")
                            // console.log('recent array in lenth 5 unique',JSON.parse(getValue1))
                        }
                    } else {
                        let setValue1 = await localStorage.setItem("qf:recent:searches", JSON.stringify(array))
                        let getValue1 = await localStorage.getItem("qf:recent:searches")
                    }

                } else {
                    if (array.length < 5) {
                        let redundant = false;
                        array.map(i1 => {
                            // console.log(i1,'in length lessthan 5')
                            if ((i1.category_name === data.category_name && data.type === i1.type && data.type === 'Category') || (i1.SERVICE_NAME === data.SERVICE_NAME && data.type === i1.type && data.type === 'Service') || (i1.MERCHANT_NAME === data.MERCHANT_NAME && data.type === i1.type && data.type === 'Professional')) {
                                // console.log('search type in cat',data.type)
                                return redundant = true;
                            }
                        })
                        if (redundant) {
                            let setValue1 = await localStorage.setItem("qf:recent:searches", JSON.stringify(array))
                            let getValue1 = await localStorage.getItem("qf:recent:searches")
                            // console.log('recent array in else redundant',JSON.parse(getValue1))
                        } else {
                            array.push(data)
                            let setValue1 = await localStorage.setItem("qf:recent:searches", JSON.stringify(array))
                            let getValue1 = await localStorage.getItem("qf:recent:searches")
                            // console.log('recent array in else',JSON.parse(getValue1))
                        }
                    }
                }
            }
        }
        if (data.type == 'Category') {
            setShowSearchDropDown(false)

            let cats = categories.filter(item => {
                return item.QF_SERVICE_CATEGORY_PRID == data.QF_SERVICE_CATEGORY_PRID
            })
            if (cats.length !== 0) {
                // setSearchTextOffer('')
                setSearchModalOpen(false)
               //  navigation.navigate('ServiceListingPage_Athome', { fromAtHomePage: true, mpidArr, categories, nearByPros, catItem: data, catPrid: data.QF_SERVICE_CATEGORY_PRID, fromExplore: false })
               navigate({
                        pathname: state.selectedServiceTab == 'at_home' ? `allservices` : `/allprofessionals`,
                        search: `?category=${data.category_name.replaceAll(" ","-","g")}&categoryId=${data.QF_SERVICE_CATEGORY_PRID}`
                      },{state:{categories,subCategories,nearByPros,catItem:data,mpidArr,catPrid:data.QF_SERVICE_CATEGORY_PRID,fromExplore:false,fromSearch:false
                        ,addressDetails:
                        {
                           totalAddress: totalAddress,
                           addressLine1: addressLine1,
                           country: country,
                           city: city,
                           stateOrProvince: stateOrProvince,
                           zipcode: zipcode,
                           district: district,
                           latitude: latitude,
                           longitude: longitude,
                           currentAddress: state.address.currentAddress,
                           searchAddress: state.address.searchAddress,
                           currentLocationDenied: state.address.currentLocationDenied,
                           categoryName:data.category_name 
                        },
                     }
                     })
                     
                     
            } else {
                setSearchTextOffer(data.category_name)
                setRecentResultsNotFound(true)
            }
            if (cats.length !== 0) {
                setSearchTextOffer('')
            }
        }
        if (data.type == 'Service') {
         console.log('service clicked')
         if(state.selectedServiceTab == 'at_home'){
            setShowSearchDropDown(false)
            // setServiceSearched(true)
            let matchesArr = []
            matchesArr.push(data)
            if (matchesArr.length !== 0) {
                // setSearchTextOffer('')
                setSearchModalOpen(false)
                console.log('data in service',data)
               //  if (data.hasAddons) {
                  //   navigation.navigate('AthomeServiceAddOnsDetails', { serviceDetails: data })
                    navigate({pathname:`/servicedetails/${data.SERVICE_NAME.replaceAll(/[&\/\\#, +()$~%.'":*?<>{}]/g, "")}` ,search:`serviceId=${data.QF_AT_HOME_SERVICE_PRID}`},{state:{serviceDetails:data}})

               //  } else {
               //      navigation.navigate('AtHomeServiceDetailsPage', { serviceDetails: data })
               //  }
            } else {
                setSearchTextOffer(data.SERVICE_NAME)
                setRecentResultsNotFound(true)
            }
            if (matchesArr.length !== 0) {
                setSearchTextOffer('')
            }
         }
         else{
            console.log('service clicked in store case')
            setShowSearchDropDown(false)
            setHiderecentSearches(true)
            setServiceSearched(true)
            setServiceSearchedName(data.SERVICE_NAME)
            setSerSearchProsLoading(true)
            let matchesArr = []
            matchesArr.push(data)
            if (matchesArr.length !== 0) {
                // setSearchModalOpen(false)
                // setSearchTextOffer('')
                let reqBody = {
                    mpidArr: mpidArr,
                    searchServiceText: data.SERVICE_NAME,
                }
                let searchData = await customFetchData('POST', reqBody, '/website/fetch/search/serviceData', state, dispatch)
                console.log('searchData', searchData)
                if (searchData.fetch) {
                    if (searchData.fetchedData && searchData.fetchedData.professionalCards.length !== 0) {
                        setSerSearchProsLoading(false)
                        // Create a map for quick lookup of professional details
                        const proDetailsMap = {};
                        nearByPros.forEach(prof => {
                            proDetailsMap[prof.QF_MERCHANT_PERSONNEL_PRID] = prof;
                        });
                        // Merge details into professionalCards
                        searchData.fetchedData.professionalCards = searchData.fetchedData.professionalCards.map(card => {
                            const details = proDetailsMap[card.professionalId];
                            return details ? { ...card, ...details } : card;
                        });
                        setServiceSearchPros(searchData.fetchedData.professionalCards)
                        // I want to open some modal and display all the professionals in a modal with their details and also the service details. I want to display the service details at the top of the modal and then all the professionals below it. I also want to display a message if no professionals are found for the searched service.
                        setSearchModalOpen(true)
                    }
                    else {
                        setSerSearchProsLoading(false)
                        // setSearchDropdownArray([])
                    }
                }
                else {
                    setSerSearchProsLoading(false)
                    // setSearchDropdownArray([])
                }
                // navigation.navigate('ProfessionalUnderCategory', { selectedServices: matchesArr, categories, subCategories, nearByPros, catItem: data, mpidArr, catPrid: data.QF_SERVICE_CATEGORY_PRID, fromServiceSearch: true })
            } else {
                setSearchTextOffer(data.SERVICE_NAME)
                setRecentResultsNotFound(true)
            }
         }
        }
        if (data.type == 'Professional') {
            setShowSearchDropDown(false)
            let offers;
            offers = nearByPros.filter(item => {
                return item.QF_MERCHANT_PERSONNEL_PRID == data.QF_MERCHANT_PERSONNEL_PRID
            })
            if (offers.length !== 0) {
                setSearchModalOpen(false)
                setSearchTextOffer('')
                navigate({pathname:`/instore/allservices/${data.MERCHANT_NAME.replaceAll(" ","","g")}`,search:`?proId=${data.QF_MERCHANT_PERSONNEL_PRID}`},{ state: {proData:data,offers:offers[0],
               categories:categories,subCategories:subCategories,
               addressDetails:
               {
                  totalAddress: totalAddress,
                  addressLine1: addressLine1,
                  country: country,
                  city: city,
                  stateOrProvince: stateOrProvince,
                  zipcode: zipcode,
                  district: district,
                  latitude: latitude,
                  longitude: longitude,
                  currentAddress: state.address.currentAddress,
                  searchAddress: state.address.searchAddress,
                  currentLocationDenied: state.address.currentLocationDenied
               },allServices:nearByPros} })
            } else {
                setSearchTextOffer(data.MERCHANT_NAME)
                setRecentResultsNotFound(true)
            }

        }

    }

 
const onClickSeebyMap = () =>{
   if(isMobileView){
      setSeeByMapModalMobile(true)
   }else{
      setSeeByMapModalWeb(true)
   }
   // navigate('/NearByProfessionalMapView',{ state: {nearByPros:nearByPros,mpidArr} })
}
const currentModalShow = () =>{
   if(currentLocModal){
      setTotalAddress(state.address.totalAddress)
   }else{
      setTotalAddress('')
   }
   setShowSearchDropDown(false)
   setSearchTextOffer('')
   setCurrentLocModal(!currentLocModal)
}
const addressSearchModalMobile = () =>{
   // searchInput.current.focus()
   // searchAddRef1.current.blur();
   setTotalAddress(state.address.totalAddress)
   setAddressSearchModal(false)
   setSearchText('')
   setRecentLocationsHide(false)
}
const handleChangeMobile = (address) =>{
   setSearchText(address)
   setTotalAddress(address)
   if(address.length > 0){
      setRecentLocationsHide(true)
   }else{
      setRecentLocationsHide(false)
   }
}
const handleSelectMobile = (address) =>{
   // console.log('address',address)
   setMapViewModal(true)
   setAddressUpDated(true)
   geocodeByAddress(address)
     .then(results => {
      //   setSearchText(results[0])
      getLatLng(results[0])
        .then(latlng =>{
            // console.log('Successfully got latitude and longitude', latlng)
            setLatitude(latlng.lat)
            setLongitude(latlng.lng)
            if(latlng.lat!==null && latlng.lng!==null){
               setSearchText(results[0].formatted_address)
               let region = {
                  center: {
                     lat:latlng.lat,
                     lng:latlng.lng
                  },
                  zoom: 15
               }
               // mapRef.current.animateToRegion(region);
               setDefaultProps(region)
              fetchAddress(latlng.lat,latlng.lng)
            //   saveLocationsInLocal(results[0].formatted_address,latlng.lat,latlng.lng)
            }
         }).then(latLng => console.log('Success', latLng))
         .catch(error => console.error('Error', error)); 
      })
}
const onClickRecentSearch = (item,saveAddressClick) =>{
   // if(isMobileView){
   //    setAddressUpDated(false)
   // }else{
      
   // }
   if(saveAddressClick){
      setSaveAddressModal(false)
      setAddressUpDated(false)
   }else{
      setAddressUpDated(true)
   }
   let latitude=item.latitude ? item.latitude : Number(item.CONSUMER_ADDRESS_LAT)
   let longitude=item.longitude ? item.longitude  : Number(item.CONSUMER_ADDRESS_LONG)
   setloadingL1(true)
   let region = {
      center: {
         lat:latitude,
         lng:longitude
      },
      zoom: 15
   }
   // mapRef.current.animateToRegion(region);
   setDefaultProps(region)
   setCurrentLocModal(false)
   setAddressSearchModal(false)
   setLatitude(latitude)
   setLongitude(longitude)
   fetchAddressRecent(latitude,longitude)
}
const addressClickMobile= () =>{
   setAddressSearchModal(true)
   // searchAddRefMob.current.blur();
   // setMapViewModal(true)
}
const LocationPinChangingHandler = (event) => {
   console.log("event",event)
   let region = {
      center: {
         lat: event.lat,
         lng: event.lng
      },
      zoom: 15
   }
   setDefaultProps(region)
   setLatitude(event.lat)
   setLongitude(event.lng)
   fetchAddress(event.lat,event.lng)
}
let seeByMapModalView=(
   <Modal isOpen={seeByMapModalWeb} size={'xl'} centered style={{borderRadius:10,width:isTabView ? '100%' :'50%'}} toggle={()=>setSeeByMapModalWeb(false)}>
      <div style={{position:'absolute',zIndex:100,right:20,top:20,backgroundColor:'#fff',borderRadius:50,width:40,height:40,justifyContent:'center',display:'flex',alignItems:'center'}}>
         <img src={CloseIcon} style={{width:25,height:25}} onClick={()=>setSeeByMapModalWeb(false)}/>
      </div>
      <div style={{padding:10,borderRadius:10}}>
         <NearByProfessionalMapView nearByPros={nearByPros} mpidArr={mpidArr} mobileView={false}/>
      </div>
   </Modal>
)
let seeByMapModalViewMobile=(
   <Modal isOpen={seeByMapModalMobile} size={'xl'} fullscreen={'xl'} toggle={()=>setSeeByMapModalMobile(false)}>
      <div style={{padding:'20px 16px 20px 16px',display:'flex',flexDirection:'row',alignItems:'center'}}>
         <img src={arrowBack} style={{transform: 'rotate(-90deg)',width:20,height:20}} onClick={()=>setSeeByMapModalMobile(false)}/>
         <text className='nearByProMapText' style={{marginLeft:15}}>Professionals nearby</text>
      </div>
      {/* <ModalHeader toggle={()=>setSeeByMapModalMobile(false)}>Professionals nearby</ModalHeader> */}
      <div>
         <NearByProfessionalMapView nearByPros={nearByPros} mpidArr={mpidArr} mobileView={true}/>
      </div>
   </Modal>
)
const MapViewModalClose=()=>{
   setAddressSearchModal(true)
   setMapViewModal(false)
   if(state.address.currentAddress){
      setCurrentAddress(state.address.totalAddress)
   }else{
      setCurrentAddress('')
   }
   setTotalAddress(state.address.totalAddress)
   setStateOrProvince(state.address.stateOrProvince)
   setZipcode(state.address.zipcode)
   setDistrict(state.address.district)
   setCity(state.address.city)
   setCountry(state.address.country)
   setAddressLine1(state.address.addressLine1)
   setLatitude(state.address.latitude)
   setLongitude(state.address.longitude)
}
const MapViewModalCloseWeb=()=>{
   setCurrentLocModal(false)
   setMapViewModalWeb(false)
   // console.log(state.address.currentAddress)
   if(state.address.currentAddress){
      setCurrentAddress(state.address.totalAddress)
   }else{
      setCurrentAddress('')
   }
   setTotalAddress(state.address.totalAddress)
   setStateOrProvince(state.address.stateOrProvince)
   setZipcode(state.address.zipcode)
   setDistrict(state.address.district)
   setCity(state.address.city)
   setCountry(state.address.country)
   setAddressLine1(state.address.addressLine1)
   setLatitude(state.address.latitude)
   setLongitude(state.address.longitude)
}
let buttonDisabled=true;
if(addressLine1 === '' || city === '' || zipcode === '' || stateOrProvince === '' || addressLine1 === null || city === null || zipcode === null || stateOrProvince === null || addressLine1 === undefined || city === undefined || zipcode === undefined || stateOrProvince === undefined){
   buttonDisabled=true
}else{
   buttonDisabled=false
}
// console.log('buttonDisabled',buttonDisabled,addressLine1,city,zipcode,stateOrProvince)
 const defaultMapOptions = {
   fullscreenControl: false,
   zoomControl:false
 };
 let backArrowBg={
   width: 36,
   height: 36,
   backgroundColor: "#ffffff",
   shadowColor: "rgba(103, 52, 204, 0.1)",
   shadowOffset: {
     width: 0,
     height: 2
   },
   shadowRadius: 4,
   shadowOpacity: 1 ,
   borderRadius:20,
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   position:'absolute',
   left:10,
   top:20,
   zIndex:100
 }
 let backArrowBgWeb={
   width: 48,
   height: 48,
   backgroundColor: "#ffffff",
   shadowColor: "rgba(103, 52, 204, 0.1)",
   shadowOffset: {
     width: 0,
     height: 2
   },
   boxShadow: '0 2px 4px 0 rgba(103, 52, 204, 0.1)',
   backgroundColor: '#fff',
   shadowRadius: 4,
   shadowOpacity: 1 ,
   borderRadius:30,
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   position:'absolute',
   left:25,
   top:25,
   zIndex:100,
   cursor:'pointer'
 }
 let currLocBgWeb={
   width: 48,
   height: 48,
   backgroundColor: "#ffffff",
   shadowColor: "rgba(103, 52, 204, 0.1)",
   shadowOffset: {
     width: 0,
     height: 2
   },
   boxShadow: '0 2px 4px 0 rgba(103, 52, 204, 0.1)',
   backgroundColor: '#fff',
   shadowRadius: 4,
   shadowOpacity: 1 ,
   borderRadius:30,
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   position:'absolute',
   right:25,
   top:25,
   zIndex:100,
   cursor:'pointer'
 }
 
//  console.log('default props',defaultProps,editNewAddressModal)
let addressSearchMapView=(
   <Modal isOpen={mapViewModal} size={'xl'} fullscreen={'xl'}>
      {/* <div style={{padding:'20px 16px 20px 16px',display:'flex',flexDirection:'row',alignItems:'center'}}>
         <img src={arrowBack} style={{transform: 'rotate(-90deg)',width:20,height:20}} onClick={()=>MapViewModalClose()}/>
         <text className='nearByProMapText' style={{marginLeft:15,color:'#8c52ff'}}>Choose location</text>
      </div> */}
      <div style={backArrowBg}>
         <img src={arrowBack} style={{transform: 'rotate(-90deg)',width:20,height:20}} onClick={()=>MapViewModalClose()}/>
      </div>
      <div style={{ height: '100%', width: '100%',borderRadius:30}}>
         <GoogleMapReact
            bootstrapURLKeys={{ key: apiKeys.googleApiKey }}
            center={defaultProps.center}
            zoom={defaultProps.zoom}
            options={defaultMapOptions}
            ref={mapRef}
            // yesIWantToUseGoogleMapApiInternals={true}
            onClick={LocationPinChangingHandler}
         >
            <div lat={defaultProps.center.lat} lng={defaultProps.center.lng}>
               <IoLocationSharp size={40} color="red"/>
            </div>          
         </GoogleMapReact>
      </div>
      <div style={{ position: 'absolute',zIndex: 100,height:160,bottom:0,left:0,right:0,boxShadow: '0 4px 50px 0 rgba(0, 0, 0, 0.2)',backgroundColor: '#fff',borderTopLeftRadius:15,borderTopRightRadius:15,padding:'15px 10px 15px 10px'}}>
         {
            loadingL1 ?
            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',padding:50}}>
               <ClipLoader widthUnit={"%"} size={20} loadings={loadingL1} color="#8c52ff" />
            </div>
            :
            <>
               <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',marginTop:10,marginBottom:20}}>
                  <div style={{display:'flex',flexDirection:'row'}}>
                     <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <img src={locationcolorIcon} style={{width:24,height:24}}/>
                     </div>
                     <div style={{display:'flex',flexDirection:'column',marginLeft:10}}>
                     <text className='addressLine1_TextHome'>{ totalAddress && totalAddress.length > 28 ? totalAddress.substr(0,28) + '...' : totalAddress}</text>
                     <text className='subText_Blw_AddressLine1'>
                        {
                           stateOrProvince + (stateOrProvince ? ", " : "") + country + (country ? ", " : "") + zipcode 
                        }
                     </text>
                     </div>
                  </div>
                  {
                  state.token ?
                  <div style={{display:'flex',justifyContent:'center',alignItems:'center',cursor:'pointer'}} onClick={()=>EditNewAddressModalOpen()}>
                     <MdOutlineEdit size={20} color="#8c52ff"/>
                  </div> : null
                  }
               </div>
               <div style={{marginTop:30}}>   
                  <Button className="saveAdd_Btn_Home" disabled={buttonDisabled ? true : false} onClick={()=>onClickConfirmLocation(totalAddress,latitude,longitude)}>
                     <text className='saveAdd_Confm_Text'>Confirm Location</text>
                  </Button>
               </div>
            </>
         }
      </div>
      <div className='currentLocationIcon_View' onClick={()=>currentLocationFunc(true)} style={{cursor:'pointer'}}>
         <img src={CurrentLocationIconRed}/>
      </div>
   </Modal>
)
let addressSearchMapViewWeb=(
   <div  style={{height:'80vh',position:'relative',borderRadius:15,padding:5}}>
      <div style={backArrowBgWeb}>
         <img src={arrowBack} style={{ transform: 'rotate(-90deg)', width: 20, height: 20 }} onClick={() => MapViewModalCloseWeb()} />
      </div>
      <div style={currLocBgWeb} onClick={() => currentLocationFunc(true)}>
         <img src={CurrentLocationIconRed} />
      </div>
      <div style={{ height: '100%', width: '100%',borderRadius:15}}>
         <GoogleMapReact
            bootstrapURLKeys={{ key: apiKeys.googleApiKey }}
            center={defaultProps.center}
            zoom={defaultProps.zoom}
            options={defaultMapOptions}
            ref={mapRef}
            // yesIWantToUseGoogleMapApiInternals={true}
            onClick={LocationPinChangingHandler}
         >
            <div lat={defaultProps.center.lat} lng={defaultProps.center.lng}>
               <IoLocationSharp size={40} color="red" />
            </div>
         </GoogleMapReact>
      </div>
      <div style={{ position: 'absolute', zIndex: 100, height: 160, bottom: 20, left: '16%', right: '16%', boxShadow: '0 5px 17px 0 rgba(0, 0, 0, 0.25)', backgroundColor: '#fff', borderRadius: 15, padding: '20px 15px 20px 15px' }}>
         {
            loadingL1 ?
               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 50 }}>
                  <ClipLoader widthUnit={"%"} size={20} loadings={loadingL1} color="#8c52ff" />
               </div>
               :
               <>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 10, marginBottom: 20 }}>
                     <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                           <img src={locationcolorIcon} style={{ width: 24, height: 24 }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                           <text className='addressLine1_TextHome'>{totalAddress && totalAddress.length > 26 ? totalAddress.substr(0,26) + '...' : totalAddress}</text>
                           <text className='subText_Blw_AddressLine1'>
                              {
                                 stateOrProvince + (stateOrProvince ? ", " : "") + country + (country ? ", " : "") + zipcode
                              }
                           </text>
                        </div>
                     </div>
                     {
                        state.token ?
                           <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,cursor:'pointer'}} onClick={() => EditNewAddressModalOpen()}>
                              <MdOutlineEdit size={20} color="#8c52ff" />
                           </div> : null
                     }
                  </div>
                  <div style={{ marginTop: 20 }}>
                     <Button className="saveAdd_Btn_Home" disabled={buttonDisabled ? true : false} onClick={() => onClickConfirmLocation(totalAddress, latitude, longitude)}>
                        <text className='saveAdd_Confm_Text'>Confirm Location</text>
                     </Button>
                  </div>
               </>
         }
      </div>
   </div>
)
let showSearchServiceProsItem = null
    if (serviceSearched) {
        if (serviceSearchPros.length !== 0) {
            showSearchServiceProsItem = (
                serviceSearchPros.map((item, index) => { 
                   return (
                      <NewProfessionalCard key={index}
                         serviceCount={item.SERVICE_COUNT} serviceName={item.SERVICE_NAME} servicePriceCurrency={item.MERCHANT_PERSONNEL_TIMEZONE === "Asia/Kolkata" ? '\u20B9' : "$"} proData={item} proArray={item} onPressCard={() => onPressProCard(item)}
                      />
        );
      })
            )
        }
    }
let searchOfferDropDownItem;
   if (nearByPros.length !== 0 && filteredArray.length !== 0 && showSearchDropDown) {
     if (searchDropdownArray.length !== 0) {
      searchOfferDropDownItem= searchDropdownArray.map((item,index)=>{
         return (
            <div style={{zIndex:2000}}>
               {item.type === 'Category' ?
                  <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', paddingTop: 10, paddingBottom: 10,borderBottom:'1px solid rgba(216, 197, 252, 0.6)' }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageCatStyle"}  style={{backgroundColor: catColors[item.category_name]}}>
                           <img src={item.category_image} style={{ width: 20, height: 20 }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection:'column',justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.category_name}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}
               {item.type === 'Professional' ?
                 <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', paddingTop: 10, paddingBottom: 10,borderBottom:'1px solid rgba(216, 197, 252, 0.6)' }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageProStyle"}>
                           <img src={item.image_link || item.MERCHANT_IMAGE || item.SAMPLE_IMAGE} style={{ width: 44, height: 44, borderRadius: 7 }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection:'column',justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.MERCHANT_NAME || item.MerchantName || item.name}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}

               {item.type === 'Service' ?
                  <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', borderBottom:'1px solid rgba(216, 197, 252, 0.6)', paddingTop: 10, paddingBottom: 10 }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageProStyle"}>
                           <img src={item.SAMPLE_IMAGE} style={{ width: 44, height: 44, borderRadius: 7 }} />
                        </div>
                        <div style={{ display: 'flex',flexDirection:'column', justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.SERVICE_NAME}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}
            </div>
         )
            })
     }
     else {
         searchOfferDropDownItem = (
             <div style={{ marginLeft: 20,marginRight:20, height: 150, justifyContent: "center", alignItems: "center", zIndex: 2000 ,display:'flex'}}>
                 <text style={{ fontSize: 12 }}>{"No results matching your search"}</text>
             </div>
         )
     }
 }
 let searchOfferDropDownItemAtHome;
   if (nearByPros.length !== 0 && filteredArray.length !== 0 && showSearchDropDown) {
     if (searchDropdownArray.length !== 0) {
      searchOfferDropDownItemAtHome= searchDropdownArray.map((item,index)=>{
         return (
            <div style={{zIndex:2000}}>
               {item.type === 'Category' ?
                  <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', paddingTop: 10, paddingBottom: 10,borderBottom:'1px solid rgba(216, 197, 252, 0.6)' }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageCatStyle"}  style={{backgroundColor: catColors[item.category_name]}}>
                           <img src={item.category_image} style={{ width: 20, height: 20 }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection:'column',justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.category_name}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}
               {item.type === 'Professional' ?
                  <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', paddingTop: 10, paddingBottom: 10,borderBottom:'1px solid rgba(216, 197, 252, 0.6)' }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageProStyle"}>
                           <img src={item.image_link || item.MERCHANT_IMAGE || item.SAMPLE_IMAGE} style={{ width: 44, height: 44, borderRadius: 7 }} />
                        </div>
                        <div style={{ display: 'flex',flexDirection:'column', justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.MERCHANT_NAME || item.MerchantName || item.name}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}
               {item.type === 'Service' ?
                  <div onClick={() => onPressSearchDropDown(item)} style={{ cursor:'pointer',backgroundColor: '#fff', borderBottom:'1px solid rgba(216, 197, 252, 0.6)', paddingTop: 10, paddingBottom: 10 }}>
                     <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                        <div className={"imageProStyle"}>
                           <img src={item.SAMPLE_IMAGE} style={{ width: 44, height: 44, borderRadius: 7 }} />
                        </div>
                        <div style={{ display: 'flex',flexDirection:'column', justifyContent: 'center', marginLeft: 22 }}>
                           <text className={"searchDropDowntextStyle"}>{item.SERVICE_NAME}</text>
                           <text className={"searchDropDownSubtextStyle"}>{item.type}</text>
                        </div>
                     </div>
                  </div>
                  : null}
            </div>
         )
            })
     }
     else {
         searchOfferDropDownItem = (
             <div style={{ marginLeft: 20,marginRight:20, height: 150, justifyContent: "center", alignItems: "center", zIndex: 2000 ,display:'flex'}}>
                 <text style={{ fontSize: 12 }}>{"No results matching your search"}</text>
             </div>
         )
     }
 }
let recentSearchesDisplay;
if(recentSearchesArray.length!==0){
   recentSearchesDisplay=recentSearchesArray.map((item)=>{
      // console.log(item)
      return (
         <div style={{cursor:'pointer',flexDirection:'row',display:'flex',alignItems:'center',paddingTop:8,paddingBottom:8}} onClick={()=>onClickRecentSearch(item)}>
            <img src={RecentLocIcon} style={{width:18,height:18}}/>
            <text className='suggestion_Text' style={{paddingLeft:5}}>{isMobileView ? (item.address.length > 38 ? item.address.substr(0,38) + "..." : item.address) : (item.address.length > 35 ? item.address.substr(0,35) + "..." : item.address)  }</text>
         </div>
      )
   })
}
let savedAddressesDisplay;
if(fetchedDataResponse.length!==0){
   savedAddressesDisplay=fetchedDataResponse.map((item)=>{
      // console.log(item)
      return (
         <div style={{cursor:'pointer',flexDirection:'row',display:'flex',alignItems:'center',position:'relative',paddingTop:8,paddingBottom:8}}>
            <MdOutlineEdit style={{position:'absolute',right:5,top:14,cursor:'pointer'}} size={14} color="#747474" onClick={()=>saveAddressModalOpen(item)}/>
            <div onClick={()=>onClickRecentSearch(item)}>
               <img src={GreyLocIcon} style={{width:18,height:18}}/>
               <text className='suggestion_Text' style={{paddingLeft:5}}>{isMobileView ? (item.CONSUMER_ADDRESS.length > 38 ? item.CONSUMER_ADDRESS.substr(0,38) + "..." : item.CONSUMER_ADDRESS) : (item.CONSUMER_ADDRESS.length > 35 ? item.CONSUMER_ADDRESS.substr(0,35) + "..." : item.CONSUMER_ADDRESS)  }</text>
            </div>
         </div>
      )
   })
}
let SearchAddressModal=(
   <Modal isOpen={addressSearchModal} size={'xl'} fullscreen={'xl'}  autoFocus={false} style={{overflow:'hidden'}}>
      <div style={{padding:16}}>
         {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
            <text className='selectLocation_Text'>Select a location</text>
            <img onClick={addressSearchModalMobile} src={CloseIcon} style={{cursor:'pointer'}}/>
         </div> */}
         <div style={{ padding: '10px 0px 10px 0px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <img src={arrowBack} style={{ transform: 'rotate(-90deg)', width: 20, height: 20 }} onClick={() => addressSearchModalMobile()} />
            <text className='nearByProMapText' style={{ marginLeft: 15, color: '#8c52ff' }}>Choose location</text>
         </div>
         <div style={{marginTop:20}}>
            <div style={{position:'relative',zIndex:100}}>
               <PlacesAutocomplete
                  // ref={searchAddRef}
                  value={searchText}
                  // autoFocus={true}
                  onChange={handleChangeMobile}
                  onSelect={handleSelectMobile}>
                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                     <div>
                        <Input
                           
                           style={{paddingLeft:50,width:'100%'}}
                           value={searchText}
                           autoFocus={true}
                           // innerRef={searchInput}
                           {...getInputProps({
                              // autoFocus:true,
                              placeholder: 'Search any address',
                              className: 'location-search-input-sv2-mobile shadow-none'
                           })}
                        />
                        {/* {console.log('suggestion', suggestions)} */}
                        <img src={searchIcon} style={{ position: 'absolute', left: 10, bottom: 11 }} />
                        <div style={{
                           border: suggestions.length !== 0 ? '2px solid #fcfcfc' : 0,
                           height: suggestions.length !== 0 ? 250 : 0,
                           overflow: suggestions.length !== 0 ? 'scroll' : 0,
                           top: suggestions.length !== 0 ? 150 : 0,
                           bottom: 0,
                           position: 'absolute',
                           zIndex: 2000,
                           width:'100%',
                           border: 'none'
                        }}
                           >
                           {/* {loading && <div>Loading...</div>} */}
                           {suggestions.map(suggestion => {
                              const className = suggestion.active
                                 ? 'suggestion-item--active'
                                 : 'suggestion-item';
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                 ? { backgroundColor: '#c5c5c5', cursor: 'pointer' }
                                 : { backgroundColor: '#ffffff', cursor: 'pointer' };
                              return (
                                 <div
                                    {...getSuggestionItemProps(suggestion, {
                                       className,
                                       style: { display: 'flex', flexDirection: 'row',alignItems:'center', paddingTop: 8, paddingBottom: 8 }
                                    })}
                                  >
                                    {/* {this.state.showDropdown === true ? <div>{suggestion.description}</div> : null}  */}
                                    {/* {console.log('data', suggestion.description)} */}
                                    <img src={GreyLocIcon} style={{width:20,height:20}}/>
                                    <text className='suggestion_Text' style={{paddingLeft:10,cursor:'pointer'}}>{suggestion.description.length > 45 ? suggestion.description.substr(0,45) + '...' : suggestion.description}</text>
                                 </div>
                              );
                           })}
                     </div>
                        
                        
                     </div>
                  )}
               </PlacesAutocomplete>
            </div>
            <div style={{ flexDirection: 'row', display: 'flex',marginTop:20,cursor:'pointer' }} onClick={()=>currentLocationFunc(true)}>
               <img src={CurrentLocationIcon} style={{ width: 20, height: 20 }} />
               <div style={{ flexDirection: 'column', display: 'flex', marginLeft: 16 }}>
                  {/* <div> */}
                  <text className='currentLoc_MainText' style={{ marginBottom: 5 }}>My Current location</text>
                  {/* </div> */}
                  {/* <div> */}
                  <text className='currentLoc_subText'>{curLocationDenied ? '' : (currentAddress ? currentAddress : '')}</text>
                  {/* </div> */}
               </div>
            </div>
            <hr/>
            <div style={{overflow:'scroll',height:450}}>
               {
                  !recentLocationsHide &&
                  (recentSearchesArray.length !==0 ?
                  <>
                     <div style={{ paddingBottom: 5 }}>
                        <text className='recentLocation_Text'>Recent Locations</text>
                     </div>
                     <div style={{ paddingTop: 5}}>
                        {recentSearchesDisplay}
                     </div>
                  </>
                  : null)
               }
               {
                  !recentLocationsHide &&
                  (fetchedDataResponse.length !==0 ?
                  <>
                     <div style={{ paddingBottom: 5 }}>
                        <text className='recentLocation_Text'>Saved Locations</text>
                     </div>
                     <div style={{ paddingTop: 5}}>
                        {savedAddressesDisplay}
                     </div>
                  </>
                  : null)
               }
            </div>
         </div>
      </div>
   </Modal>
)
const saveAddressModalOpen = (item) =>{
   setCurrentLocModal(false)
   setSelectedTag(item.CONSUMER_ADDRESS_SELECTED_TAG)
   placesArray.map(item1=>{
       if(item1.place === item.CONSUMER_ADDRESS_SELECTED_TAG){
       // console.log('items yes',item.id === data.id ,item.id,data.id)
           return setClickedValue({
               ['clickedValue_'+ item1.id]:true   
           })
       }
   })
   setAllValues({
       ...allValues,
       cmptAddress:item.CONSUMER_ADDRESS_LINE2,
       floor:item.CONSUMER_ADDRESS_LINE3,
       landmark:item.CONSUMER_ADDRESS_LINE4
   })
   setEditAddress(item)
   setSaveAddressModal(true)
   setStateOrProvince(item.CONSUMER_ADDRESS_STATE)
   setZipcode(item.CONSUMER_ADDRESS_ZIPCODE)
   setDistrict(item.CONSUMER_ADDRESS_DISTRICT)
   setCity(item.CONSUMER_ADDRESS_CITY)
   setCountry(item.CONSUMER_ADDRESS_COUNTRY)
   setAddressLine1(item.CONSUMER_ADDRESS_LINE1)
   setLatitude(Number(item.CONSUMER_ADDRESS_LAT))
   setLongitude(Number(item.CONSUMER_ADDRESS_LONG))
}
const EditNewAddressModalOpen = () =>{
   setEditNewAddressModal(true)
   setEditAddress({})
}
const EditNewAddressModalClose = () =>{
   setEditNewAddressModal(false)
   placesArray.map((item, index) => {
      if (item.id === 1) {
          // console.log('place array1',item)
          return clickedValue['clickedValue_' + item.id] = true

      } else {
          // console.log('place array2',item)
          return clickedValue['clickedValue_' + item.id] = false
          // console.log('placse array',clickedValue)
      }
  })
}
const saveAddressModalClose = () =>{
   setSaveAddressModal(false)
   if(!isMobileView){
      setCurrentLocModal(true)
   }
   setAllValues({
      cmptAddress: '',
      floor: '',
      landmark: '',
      status: '',
      message: '',
      addError: false,
      floorError: false,
      landError: false
   })
   setEditAddress({})
   placesArray.map((item, index) => {
      if (item.id === 1) {
          // console.log('place array1',item)
          return clickedValue['clickedValue_' + item.id] = true

      } else {
          // console.log('place array2',item)
          return clickedValue['clickedValue_' + item.id] = false
          // console.log('placse array',clickedValue)
      }
  })
  setStateOrProvince(state.address.stateOrProvince)
  setZipcode(state.address.zipcode)
  setDistrict(state.address.district)
  setCity(state.address.city)
  setCountry(state.address.country)
  setAddressLine1(state.address.addressLine1)
  setLatitude(state.address.latitude)
   setLongitude(state.address.longitude)
}
let smallCardStyle={
   width: '70px',
   height: '25px',
   display: 'flex',
   // flexDirection: 'row',
   justifyContent: 'center',
   alignItems: 'center',
   borderRadius: '7px',
   border:'solid 1px rgba(116,116,116,0.4)',
   marginRight:20,
   // padding:10
}
let smallCardSelectedStyle={
   width: '70px',
   height: '25px',
   display: 'flex',
   // flexDirection: 'row',
   justifyContent: 'center',
   alignItems: 'center',
   borderRadius: '7px',
   border: 'solid 1px #8c52ff',
   backgroundColor:'rgba(216,197,252,0.6)',
   marginRight:20,
   // padding:10
}
//// onClick func to active card with backgroud color
const onPressSmallCard = (data) => {
   // console.log('values', data)
   setSelectedTag(data.place)
   placesArray.map(item=>{
       if(item.id === data.id){
       // console.log('items yes',item.id === data.id ,item.id,data.id)
           return setClickedValue({
               ['clickedValue_'+ item.id]:true   
           })
       }
   })
   // console.log('clicked value',clickedValue)
}
const CompleteAddressHandler = (event) => {
   let value=event.target.value
   // if (value.trim() === '') {
   //     setAllValues({
   //         ...allValues,
   //         cmptAddress: '',
   //         addError: true,
   //         status: 'error',
   //         message: 'Please enter complete address'
   //     })
   // } else {
       setAllValues({
           ...allValues,
           cmptAddress: value,
           status: '',
           addError: false,
       })
   // }
}
const FloorHandler = (event) => {
   let value=event.target.value
   setAllValues({
       ...allValues,
       floor: value
   })
}
const LandmarkHandler = (event) => {
   let value=event.target.value
   setAllValues({
       ...allValues,
       landmark: value
   })
}
const onCompleteAddressSubmit = () => {
   // if (allValues.cmptAddress.trim() === '') {
   //     setAllValues({
   //         ...allValues,
   //         status: 'error',
   //         message: 'Please enter complete address',
   //         addError: true
   //     })
   // } else {
       setAllValues({ ...allValues, addError: false })
       input_Ref1.current.focus()
   // }
}
const onFloorSubmit = () => {
   setAllValues({ ...allValues, floorError: false })
   input_Ref2.current.focus()
}
const onLandmarkSubmit = () => {
   setAllValues({ landError: false })
   // Keyboard.dismiss();
}
const clickOnSaveAddress = async() =>{
   try {
      // if (allValues.cmptAddress.trim() === '') {
      //     setAllValues({
      //         ...allValues,
      //         status: 'error',
      //         message: 'Please enter complete address',
      //         addError: true
      //     })
      // }else{
         let body;
         if(Object.keys(editAddress).length !== 0){
            body = {
                totalAddress: editAddress.CONSUMER_ADDRESS,
                latitude: editAddress.CONSUMER_ADDRESS_LAT,
                longitude: editAddress.CONSUMER_ADDRESS_LONG,
                city: editAddress.CONSUMER_ADDRESS_CITY,
                country: editAddress.CONSUMER_ADDRESS_COUNTRY,
                state: editAddress.CONSUMER_ADDRESS_STATE,
                zipcode: editAddress.CONSUMER_ADDRESS_ZIPCODE,
                district: editAddress.CONSUMER_ADDRESS_DISTRICT,
                addressLine1: editAddress.CONSUMER_ADDRESS_LINE1,
                addressLine2: allValues.cmptAddress ? allValues.cmptAddress : null ,
                addressLine3: allValues.floor ? allValues.floor : null,
                addressLine4: allValues.landmark ? allValues.landmark : null,
                selectedTag: selectedTag,
                uid:state.user.id  
            }
        }else{
          body = {
              totalAddress: totalAddress ? totalAddress : currentAddress,
              latitude: latitude,
              longitude: longitude,
              city: city,
              country: country,
              state: stateOrProvince,
              zipcode: zipcode,
              district: district,
              addressLine1: addressLine1,
              addressLine2: allValues.cmptAddress,
              addressLine3: allValues.floor,
              addressLine4: allValues.landmark,
              selectedTag: selectedTag,
              uid:state.user.id
          }
         }
          // console.log('body', body)
          let method = 'POST';
          let url = "/website/addressSave/sv2"
          let useFetchRes = await customFetchData(method, body, url, state, dispatch)
          // console.log('response', useFetchRes)
          if (useFetchRes.fetch) {
            // setSaveAddressModal(false)
            // setCurrentLocModal(false)
            // setEditNewAddressModal(false)
            // setMapViewModal(false)
            // setMapViewModalWeb(false)
            // setEditAddress({})
              setAllValues({ ...allValues, cmptAddress: '', floor: '', landmark: '', addError: '', status: '' })
              placesArray.map((item,index)=>{
                  if(item.id === 1){
                      // console.log('place array1',item)
                     return  clickedValue['clickedValue_'+ item.id]=true
                      
                  }else{
                      // console.log('place array2',item)
                     return clickedValue['clickedValue_'+ item.id]=false
                      // console.log('placse array',clickedValue)
                  }
              })
              if(editNewAddressModal){
               // console.log('entered 12')
                  onClickConfirmLocation(totalAddress,latitude,longitude)
              }else{
                  // console.log('entered 123')
                  onClickRecentSearch(editAddress,true)
              }
              toast(
               <div style={{display:'flex',justifyContent:'center'}}>
                  <text style={{textAlign:'center'}}>address saved successfully</text>
               </div>
               , {
               position: "bottom-center",
               hideProgressBar: true,
               progress: undefined,
               closeButton:false,
               style:{backgroundColor:'#E0D1FF'}
           });
            //   toast.success(<text style={{textAlign:'center'}}>address saved successfully</text>, { position: toast.POSITION.BOTTOM_CENTER })
          }
      // }
  }
  catch (error) {
      toast.warn(<text style={{textAlign:'center'}}>something went wrong</text>, { position: toast.POSITION.BOTTOM_CENTER });
  }
}
const onPressProCard = (item, id) => {
        let offers;
        offers = nearByPros.filter(item1 => {
            return item1.QF_MERCHANT_PERSONNEL_PRID == item.QF_MERCHANT_PERSONNEL_PRID
        })
        if (offers.length !== 0) {
            setSearchModalOpen(false)
            setSearchTextOffer('')
            setServiceSearched(false)
            navigate({pathname:`/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ","","g")}`,search:`?proId=${item.QF_MERCHANT_PERSONNEL_PRID}`},{ state: {proData:item,offers:offers[0],
               categories:categories,subCategories:subCategories,
               addressDetails:
               {
                  totalAddress: totalAddress,
                  addressLine1: addressLine1,
                  country: country,
                  city: city,
                  stateOrProvince: stateOrProvince,
                  zipcode: zipcode,
                  district: district,
                  latitude: latitude,
                  longitude: longitude,
                  currentAddress: state.address.currentAddress,
                  searchAddress: state.address.searchAddress,
                  currentLocationDenied: state.address.currentLocationDenied
               },allServices:nearByPros} })
        }
    }
let textStyle={
   width:'100%',
   opacity: 0.4,
   fontFamily: 'Inter',
   fontSize: 12,
   fontWeight: 'normal',
   fontStretch: 'normal',
   fontStyle: 'normal',
   lineHeight: 'normal',
   letterSpacing: 'normal',
   textAlign: 'left', 
   color:'#8c52ff',
}
let errorBox={
   borderRadius: 4.2,
   backgroundColor: "#ffe4c5",
   shadowColor: "rgba(0, 0, 0, 0.04)",
   shadowOffset: {
     width: 0,
     height: 0
   },
   shadowRadius: 31,
   shadowOpacity: 1,
   display:"flex",
   justifyContent: "center",
   alignItems: "center", 
   paddingTop:5,
   paddingBottom:5
}
let errorText={
   fontFamily: "Inter",
   fontSize: 12.5,
   fontWeight: "600",
   fontStyle: "normal",
   letterSpacing: 0,
   textAlign: "center",
   color: "#f3972d"
}
let addressFieldsContent=(
   <div>
      <div style={{marginTop:10}}>
            <text className='enterText_Address'>Enter complete address</text>
         </div>
         <hr/>
         <div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
               <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={locationcolorIcon} style={{ width: 24, height: 24 }} />
               </div>
               <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
               <text className='addressLine1_TextHome'>{isMobileView ? (totalAddress && totalAddress.length > 28 ? totalAddress.substr(0,28) + '...' : totalAddress) : (totalAddress && totalAddress.length > 30 ? totalAddress.substr(0,30) + '...' : totalAddress)}</text>
               <text className='subText_Blw_AddressLine1'>
                  {
                     stateOrProvince + (stateOrProvince ? ", " : "") + country + (country ? ", " : "") + zipcode
                  }
               </text>
               </div>
            </div>
         </div>
         <div>
            {
               allValues.status == 'error' &&
               <div>
                  <div style={errorBox}>
                     <text style={errorText}>{allValues.message}</text>
                  </div>
               </div>
            }
            <div style={{paddingTop:20}}>
               <InputComponent
                  inputWidthStyle={'100%'} 
                  InputFields={{
                     type:"text",
                     // placeholderTextColor: '#8c52ff',
                     onChange: CompleteAddressHandler,
                     value: allValues.cmptAddress,
                     placeholder: "Complete Address",
                     // onKeyDown: () => onCompleteAddressSubmit(),
                     blurOnSubmit: false,
                     error: allValues.addError,
                     className:'my-inputPlaceHolder'
                     // returnKeyType: "next"
                 }}
                 textStyle={textStyle}
               />
            </div>
            <div style={{paddingTop:20}}>
               <InputComponent 
                  inputWidthStyle={'100%'}
                  InputFields={{
                     type:"text",
                     // placeholderTextColor: '#9d9d9d',
                     onChange: FloorHandler,
                     value: allValues.floor,
                     placeholder: "Floor (Optional)",
                     innerRef: input_Ref1,
                     // onKeyDown: () => onFloorSubmit(),
                     blurOnSubmit: false,
                     error: allValues.floorError,
                     className:'my-inputPlaceHolder',
                     // onSubmitEditing:() => onFloorSubmit()
                     // returnKeyType: "next"
                  }}
                  textStyle={textStyle}
               />
            </div>
            <div style={{paddingTop:20}}>
               <InputComponent 
                  inputWidthStyle={'100%'}
                  InputFields={{
                     type:"text",
                     // placeholderTextColor: '#9d9d9d',
                     onChange: LandmarkHandler,
                     value: allValues.landmark,
                     placeholder: "Nearby landmark (Optional)",
                     //   keyboardType="default"
                     // returnKeyType: "done",
                     // onKeyDown: () => onLandmarkSubmit(),
                     blurOnSubmit: false,
                     innerRef: input_Ref2,
                     error: allValues.landError,
                     className:'my-inputPlaceHolder',
                     // onSubmitEditing:() => onLandmarkSubmit()
                 }}
                 textStyle={textStyle}
               />
            </div>
         </div>
         <div style={{marginTop:10}}>
            <text className='saveAdreesAs_Text'>Save address as*</text>
            <div style={{display: 'flex', flexDirection: 'row',marginTop:10}}>
               {
                  placesArray.length!==0 &&
                  placesArray.map(item=>{
                     return <div onClick={()=>onPressSmallCard(item)} style={clickedValue['clickedValue_'+ item.id] ? smallCardSelectedStyle : smallCardStyle}>
                        <text className='saveAdreesAs_Text' style={{color:clickedValue['clickedValue_'+ item.id] ? '#8c52ff' : '#747474'}}>{item.place}</text>
                     </div>
                  })
               }
            </div>
         </div>
         <div style={{marginTop:20,marginBottom:20}}>
            <Button className='saveAdd_Btn_Home' onClick={()=>clickOnSaveAddress()} disabled={buttonDisabled ? true : false}>
               <text className='saveAdd_Confm_Text'>
                  Save Address
               </text>
            </Button>
         </div>
   </div>
)
let saveAddressModalDisplay=(
   <Modal isOpen={saveAddressModal} size={'md'} toggle={() => saveAddressModalClose()} centered>
      <div style={{padding:20}}>
         <div style={{ justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
            <div className='crossIcon_ViewPro_Home' style={{ cursor: 'pointer' }}>
               <img src={CloseIcon} style={{ width: 18, height: 18 }} onClick={() => saveAddressModalClose()} />
            </div>
         </div>
         {addressFieldsContent}
      </div>
   </Modal>
)
let editAddressModalDisplay=(
   <Modal isOpen={editNewAddressModal} size={'md'} toggle={()=>EditNewAddressModalClose()} centered>
      <div style={{padding:20}}>
         <div style={{ justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
            <div className='crossIcon_ViewPro_Home' style={{ cursor: 'pointer' }}>
               <img src={CloseIcon} style={{ width: 18, height: 18 }} onClick={() => EditNewAddressModalClose()} />
            </div>
         </div>
         {addressFieldsContent}
      </div>
   </Modal>
)
let searchModalDisplay=(
   <Modal isOpen={searchModalOpen} size={'md'} toggle={() => setSearchModalOpen(false)} centered>
      {/* Here I want to render all the searchedPros cards vertically in a modal */}
         <div style={{padding:20}}>
            <div style={{ justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
               <div className='crossIcon_ViewPro_Home' style={{ cursor: 'pointer' }}>
                  <img src={CloseIcon} style={{ width: 18, height: 18 }} onClick={() => setSearchModalOpen(false)} />
               </div>
            </div>
            <div style={{marginTop:10}}>
               <text className='searchOffer_Text'>Search results for "{serviceSearchedName}"</text>
            </div>
            {/* I want to render serviceSearchPros Array. Please display all the items in serviceSearchPros. Use map and display and call the NewProfessaionalCard component */}
            {serviceSearchPros.length !== 0 ?
   serviceSearchPros.map((item, index) => {
      return (
         <div style={{ marginTop: 10 }} key={index}>
            <NewProfessionalCard
               key={index}
               serviceCount={item.SERVICE_COUNT} fromServiceSearch= {true} serviceName={item.SERVICE_NAME} servicePriceCurrency={item.MERCHANT_PERSONNEL_TIMEZONE === "Asia/Kolkata" ? '\u20B9' : "$"} proData={item} proArray={item} onPressCard={() => onPressProCard(item)}
            />
         </div>
      )
   })
   :
   <div style={{marginTop:20,display:'flex',justifyContent:'center'}}>
      <text style={{fontSize:14}}>No professionals found matching your search</text>
   </div>
            }
            <hr/>
           {/*  */}
         </div>
      
   </Modal>
)


let noOffersStyle={
   fontFamily: "Inter",
   fontSize: 14,
   fontWeight: "normal",
   fontStyle: "normal",
   letterSpacing: 0,
   textAlign: "center",
   color: "#563951"
 }
// console.log('state',state,searchDropdownArray)

const keywords={
   'at_home': `
       home services,
       on demand services,
       local service providers,
       service marketplace,
       book services online,
       trusted professionals near me,
       home cleaning,
       beauty services,
       repair services,
       maintenance services,
       book service app,
       book home services near me,
       find trusted professionals near me,
       affordable home services near me,
       best service provider platform,
       at home services,
       home services near me,
       salon at home, repair at home,
       cleaning services at home,
       beauty services at home,
       electrician at home,
       plumber at home,
       appliance repair at home,
       doorstep services,book at home services near me,
       salon services at home near me,
       home repair services near me,
       doorstep beauty services near me
   `,
   'in_store': `
       home services, home services near me,
       on demand services,
       local service providers,
       service marketplace,
       book services online,
       trusted professionals near me,
       home cleaning,
       beauty services,
       repair services,
       maintenance services,
       book service app,
       book home services near me,
       find trusted professionals near me,
       affordable home services near me,
       best service provider platform,
       in store services,
       services near me,
       nearby service stores,
       book services near me,
       salon near me,
       repair shop near me,
       service center near me,
       beauty salon near me,
       appliance service center,
       find service stores near me,
       book in store services near me,
       nearby beauty salon services,
       local repair services near me"
   `
}

// const description={
//    'at_home': "GoSlash connects you with verified professionals for home and personal services. Book trusted experts for cleaning, beauty, repair, and maintenance—at home or in-store, with easy scheduling and transparent pricing,Book trusted at-home services with GoSlash. From beauty and cleaning to repairs and maintenance, verified professionals deliver quality services right to your doorstep with flexible scheduling and reliable service.",
//    'in_store': "GoSlash connects you with verified professionals for home and personal services. Book trusted experts for cleaning, beauty, repair, and maintenance—at home or in-store, with easy scheduling and transparent pricing,Discover reliable in-store services near you with GoSlash. Explore verified service providers, compare options, and book appointments easily at nearby stores for beauty, repairs, and maintenance services"
// }
const description={
   'at_home': "Book trusted professionals for cleaning, appliance repair, beauty, pest control, electrical services and more — all from one easy app.",
   'in_store': "Book trusted professionals for beauty, hair, nails, and more — all from one easy app."
}
// console.log('selected service tab',description[state.selectedServiceTab])
   return (



      <div>

         <Helmet>
            <title>SLASH | Your All-in-One App for Hassle-Free At-Home Services, Including Cleaning, Beauty, Appliance Repair, Electrical & More | {categoryName ? categoryName : state.address.city}  </title>
            <meta name="description" content={description[state.selectedServiceTab]} />
            <meta name="keywords" content={keywords[state.selectedServiceTab]} />
         </Helmet>

         <div style={{position:'relative', background: 'linear-gradient(to top, rgba(0, 0, 0) 100%, rgba(0, 0, 0) 0%)'}}>
            <div className='searchAndText_Banner_Sv2'>
               {/* <div style={{display:'flex',justifyContent:'center'}}> */}
               <h1
                  className="Carousel_Text_Banner_Sv2"
                  style={{ textAlign: isMobileView ? "left" : "center" }}
               >
                  {state.selectedServiceTab === "in_store" ? (
                     <>
                        Expert Services, Available{" "}
                        <span style={{ color: "#bca1f2" }}>In-Store</span>
                     </>
                  ) : (
                     <>
                        Professional <span style={{ color: "#bca1f2" }}>Home Services</span> On Demand
                     </>
                  )}
               </h1>

               {/* </div> */}
               {/* <div style={{display:'flex',justifyContent:'center'}}> */}
                  <p className='subText_Carousel_Sv2' style={{textAlign:isMobileView ? 'left' : 'center'}}>
                     { state.selectedServiceTab == 'in_store' ? "Trusted professionals, right where customers already are." : "Book verified professionals for cleaning, repairs, and home services. Quality work delivered to your doorstep."}
                  </p>
               {/* </div> */}
               <div style={{display:'flex',justifyContent:'center'}}>
                  {
                  isMobileView ?
                  <div  style={{display:'flex',flexDirection:'column',marginTop:20}}>
                     <div style={{position:'relative',width:'100%'}}>
                        <div onClick={addressClickMobile}>
                           <Input
                           innerRef={searchAddRefMob}
                              value={totalAddress}
                              className='inputSearchCatSerPro_Style_Mobile shadow-none'
                              placeholder='Search any address'
                              onChange={addressClickMobile}
                              
                           />
                           <img src={locationcolorIcon} style={{ position: 'absolute', left: 5, bottom: 15 }} />
                                 {
                                    loadingL ?
                                       <div style={{ display: 'flex', bottom: 16, right: 40, position: 'absolute' }}>
                                          <ClipLoader widthUnit={"%"} size={12} loadings={loadingL} color="#8c52ff" />
                                       </div>
                                       : null
                                 }
                           <img onClick={()=>addressClickMobile()} style={{position:'absolute',right:10,bottom:15,transform:addressSearchModal ? 'rotate(360deg)' : 'rotate(180deg)'}} src={arrowBack}/>
                        </div>
                     </div>
                     <div style={{position:'relative',marginTop:20}}>
                        <img src={searchIcon} style={{position:'absolute',left:5,bottom:10}}/>
                        {
                        searchTextOffer &&
                        <div style={{position:'absolute',display: 'flex',justifyContent:'center',right:8,bottom:12}} onClick={clearSearchResults}>
                           <img src={SearchCrossIcon} style={{width:20,height:20}}/>
                        </div>
                        }
                        <Input type="text" 
                        placeholder={state.selectedServiceTab == 'at_home' ? 'Search any Service / Category' :'Search any Service / Professional / Category' }
                        className='inputSearchCatSerPro_Style_Mobile shadow-none'
                        onChange={searchBoxOfferhandler}
                        value={searchTextOffer}
                        // returnType="done"
                        onSubmitEditing={clearSearchResults}/>
                        {showSearchDropDown ? <Card style={{position:'absolute', height:searchDropdownArray.length > 0 ? (searchDropdownArray.length == 1 || searchDropdownArray.length == 2 ? 'auto' : 260) : 150,top:55,left:-30,right:-30, zIndex: 2000 ,overflow:'auto'}}>
                           {state.selectedServiceTab == 'at_home' ?  searchOfferDropDownItemAtHome : searchOfferDropDownItem}
                         </Card> : null}
                     </div>
                  </div>
                  :
                  <div  style={{display:'flex',flexDirection:'row',marginTop:30}}>
                     <div style={{position:'relative'}}>
                        <PlacesAutocomplete
                           value={totalAddress}
                           // ref={searchAddRef}
                           onChange={handleChange}
                           onSelect={handleSelect}>
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                          <div>
                                                <Input
                                                innerRef={searchAddRef}
                                                value={totalAddress}
                                                onClick={()=>currentModalShow()}
                                                {...getInputProps({
                                                   placeholder: 'Search any address',
                                                   className: 'location-search-input-sv2 shadow-none'
                                                })}
                                                style={{cursor:'pointer'}}
                                                />
                                                {/* {console.log('suggestion',suggestions)} */}
                                                <img src={locationcolorIcon} style={{position:'absolute',left:5,bottom:15,cursor:'pointer'}}/>
                                                {
                                                   loadingL ? 
                                                   <div style={{display: 'flex',bottom:16,right:40,position:'absolute'}}>
                                                      <ClipLoader widthUnit={"%"} size={12} loadings={loadingL} color="#8c52ff" />
                                                   </div>
                                                   : null
                                                }
                                                <img onClick={()=>currentModalShow()} style={{cursor:'pointer',position:'absolute',right:5,bottom:15,transform:currentLocModal ? 'rotate(360deg)' : 'rotate(180deg)'}} src={arrowBack}/>
                                                   <Card style={{
                                                      border: suggestions.length !==0 ? '2px solid #fcfcfc' : 0,
                                                      height: suggestions.length !==0 ? 200 : 0,
                                                      overflow : suggestions.length !==0 ? 'scroll' : 0,
                                                      top:suggestions.length !==0 ? 55 : 0,
                                                      bottom:0,
                                                      position:'absolute',
                                                      zIndex:2000,
                                                      paddingRight:10,
                                                      paddingLeft:10,
                                                      paddingRight:10,
                                                      width:300
                                                      }}
                                                      className='dropDownCardWidth_sv2'>
                                                   {/* {loading && <div>Loading...</div>} */}
                                                   <div style={{marginTop:10,marginBottom:10}}>
                                                      {suggestions.map(suggestion => {
                                                         const className = suggestion.active
                                                         ? 'suggestion-item--active'
                                                         : 'suggestion-item';
                                                         // inline style for demonstration purpose
                                                         const style = suggestion.active
                                                         ? { backgroundColor: '#c5c5c5', cursor: 'pointer' }
                                                         : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                         return (
                                                         <div
                                                            {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                            style:{display:'flex',flexDirection:'row',paddingTop:5,paddingBottom:5}
                                                            })}
                                                         >
                                                            {/* {this.state.showDropdown === true ? <div>{suggestion.description}</div> : null}  */}
                                                            {/* {console.log('data',suggestion.description)} */}
                                                            <text className='suggestion_Text' style={{cursor:'pointer'}}>{suggestion.description}</text>
                                                         </div>
                                                         );
                                                })}
                                                   </div>
                                                   </Card>
                                                   {
                                                      currentLocModal ? 
                                                      <Card className='CurrentLocation_Modal_Style' style={{height:recentSearchesArray.length !==0 && fetchedDataResponse.length !==0 ? 250 : (recentSearchesArray.length !==0 || fetchedDataResponse.length !==0 ? 240 : 100)}}>
                                                         <div style={{position:'relative'}}>
                                                           <div style={{flexDirection:'row',display:'flex',marginTop:10,cursor:'pointer'}} onClick={()=>currentLocationFunc(true)}>
                                                               <img src={CurrentLocationIcon} style={{width:20,height:20}}/>
                                                               <div style={{flexDirection:'column',display:'flex',marginLeft:16}}>
                                                                     <text className='currentLoc_MainText' style={{marginBottom:5}}>My Current location</text>
                                                                     {/* {
                                                                        loadingL ? 
                                                                        <div style={{display: 'flex', flexDirection: 'column',paddingLeft:30,paddingTop:10, justifyContent: 'center', alignItems: 'center'}}>
                                                                           <ClipLoader widthUnit={"%"} size={12} loadings={loadingL} color="#8c52ff" />
                                                                        </div>
                                                                        // <ClipLoader/>
                                                                        : */}
                                                                        <text className='currentLoc_subText' style={{paddingRight:5}}>{curLocationDenied ? '' : (currentAddress ? currentAddress : '')}</text>
                                                                     {/* } */}
                                                               </div>
                                                            </div>
                                                            {/* {state.token ? <div style={{position:'absolute',right:5,top:6,cursor:'pointer'}} onClick={()=>saveAddressModalOpen()}>
                                                               <MdOutlineEdit size={15} color="#8c52ff"/>
                                                            </div> : null} */}
                                                         </div>
                                                         <hr/>
                                                         <div style={{overflow: 'scroll',marginTop:5,marginBottom:5}}>

                                                            {
                                                               recentSearchesArray.length!==0 ?
                                                               <>
                                                                  <div style={{marginBottom:5}}>
                                                                     <text className='recentLocation_Text'>Recent Locations</text>
                                                                  </div>
                                                                  <div style={{marginTop:5,overflow:'scroll'}}>
                                                                     {recentSearchesDisplay}
                                                                  </div>
                                                               </>
                                                               : null
                                                            }
                                                            {
                                                               fetchedDataResponse.length !== 0 ?
                                                                  <>
                                                                     <div style={{ paddingBottom: 5 }}>
                                                                        <text className='recentLocation_Text'>Saved Locations</text>
                                                                     </div>
                                                                     <div style={{ marginTop: 5, overflow: 'scroll' }}>
                                                                        {savedAddressesDisplay}
                                                                     </div>
                                                                  </>
                                                                  : null
                                                            }
                                                         </div>
                                                      </Card>
                                                      :
                                                      null
                                                   }
                                          </div>
                                          )}
                        </PlacesAutocomplete>
                     </div>
                     <div style={{position:'relative'}}>
                        <div className='verticalline_sv2'></div>
                        <img src={searchIcon} style={{position:'absolute',left:20,bottom:10}}/>
                        {
                        searchTextOffer &&
                        <div style={{position:'absolute',cursor:'pointer',right:8,bottom:12}} onClick={clearSearchResults}>
                           <img src={SearchCrossIcon} style={{width:20,height:20}}/>
                        </div>
                        }
                        <Input 
                        type="text" 
                        placeholder={state.selectedServiceTab == 'at_home' ? 'Search any Service / Category' :'Search any Service / Professional / Category' }
                        className='inputSearchCatSerPro_Style shadow-none'
                        onChange={searchBoxOfferhandler}
                        value={searchTextOffer}
                        // returnType="done"
                        onSubmitEditing={clearSearchResults}
                        // onPressCross={clearSearchResults}
                        // searchTextOffer={searchTextOffer}
                        />
                        {showSearchDropDown ? <Card style={{position:'absolute', height: searchDropdownArray.length > 0 ? (searchDropdownArray.length == 1 || searchDropdownArray.length == 2 ? 'auto' : 220) : 150,top:55,left:30, zIndex: 2000 ,width:300,overflow:'auto'}}>
                           {state.selectedServiceTab == 'at_home' ?  searchOfferDropDownItemAtHome : searchOfferDropDownItem}
                         </Card> : null}
                         
                     </div>
                  </div>
                  }
               </div>
            </div>
               <img className="homePage_Banner_Img" src={ state.selectedServiceTab == 'at_home' ? (isMobileView ? 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767689086055-lg.webp' : 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767689025729-lg.webp') : (isMobileView ? 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767689024425-lg.webp' : 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767689022939-lg.webp')}/>
         </div>
         <div style={{position:'relative',cursor:'pointer'}}>
         </div>
         {/* Address Related Modals */}
         {mapViewModal && addressSearchMapView}
         {
            mapViewModalWeb &&
            <Modal isOpen={mapViewModalWeb} size={'xl'} centered style={{borderRadius:15,width:isTabView ? '100%' :'50%'}} toggle={() => MapViewModalCloseWeb()}>
               {/* <div style={{}}> */}
                  {addressSearchMapViewWeb}
               {/* </div> */}
            </Modal>
         }
         {addressSearchModal && SearchAddressModal}
         {saveAddressModal && saveAddressModalDisplay}
         {editNewAddressModal && editAddressModalDisplay}
         {searchModalOpen && searchModalDisplay}
         {/* Categories and Professional Section */}
              {
               categories.length!==0 ?
               <>
                  <div className="MainReusable_Container_Home offer_Bottom_Home" style={{backgroundColor:'#f1f1f1'}}>
                     <div style={{ paddingTop: 20, flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h1 className='service_offered_maintext'>Services we Offer</h1>
                        <h2 className='service_offer_subtext'>Book with our most trusted professionals</h2>
                     </div>
                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {
                           loadingCat ?
                           <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                              <ClipLoader widthUnit={"%"} size={40} loadings={loadingCat} color="#8c52ff" />
                           </div>
                           :
                           <Card style={{ width: widthCal, border: 'none', backgroundColor:'#f1f1f1' }}>
                              <CardBody style={{ padding: 0, justifyContent: 'center', alignItems: 'flex-start', display: 'flex', flexWrap: 'wrap' }}>
                                 {categoryCards}
                              </CardBody>
                           </Card>
                        }
                     </div>
                  </div>

                  {/* Near by Professionals */}
                  {/* {
                     nearestPros.length !== 0 ?
                     <div className="MainReusable_Container_Home">
                        <div>
                           <text className='Professionals-nearby'>Professionals  nearby</text>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                           <text className='NearByPro_BSubtext'>Book services in your neighbourhood</text>
                        </div>
                        <div className='bigHorZLine'>
                        </div>
                        {
                           loadingCat ?
                              <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                 <ClipLoader widthUnit={"%"} size={40} loadings={loadingCat} color="#8c52ff" />
                              </div>
                              : 
                           nearByProCardDisplay
                        }
                     </div>
                     : null
                  } */}
               </>
               :
               
                  loadingCat ?
                     <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        <ClipLoader widthUnit={"%"} size={40} loadings={loadingCat} color="#8c52ff" />
                     </div>
                     : 
                     <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <text style={{textAlign:'center'}}>{cityNotYet ? "We are not yet available in your city. Please check back later." : "No services to display"}</text>
                     </div>
               
              }
         
               {seeByMapModalWeb && seeByMapModalView}
               {seeByMapModalMobile && seeByMapModalViewMobile}
         {/* Why Slash Cards */}
         <div>
            {isMobileView ?  <WhyChooseSlash_Mobile selectedServiceTab={state.selectedServiceTab}/> : <WhyChooseSlash selectedServiceTab={state.selectedServiceTab}/>}
         </div>
         <>
          <BookAserviceWithUs/>
         </>
         {/* <div>
            <Testimonials/>
         </div> */}
         <ToastContainer/>
      </div>

   )
}

export default React.memo(LandingPageV2)
